import { recentCohortQuery } from "./utils";
import moment from "moment";

const today = new Date();
const new_building_start = today.getFullYear() - 7;

export const _companyFilters = [
  {
    //"Developer", "Marketing", "Expeditor",  "Engineer", "Architect", "Interior Designer", "Lender", "Construction", "Property Manager","Commercial Broker", "Residential Broker", "Other"
    //"developer", "marketing", "expeditor", "engineer", "architect", "interior designer", "lender", "construction", "commercial broker", "residential broker", "Other"
    name: "Category / Role",
    show_name: true,
    search_key: "organizations.categories",
    filter_type: "company",
    multi_filter: true,
    value_contains_key: true,
    values: [
      {
        name: "Any",
        filter: "",
        dropdown_name: "Any",
        search_value: "",
      },
      {
        name: "Permit Applicant",
        filter: "applicant",
        dropdown_name: "Permit Applicant",
        search_value: {
          "organizations.project_roles": {
            $in: ["applicant", "permit applicant"],
          },
        },
      },
      {
        name: "Permit Filing Rep",
        filter: "filing-rep",
        dropdown_name: "Permit Filing Rep",
        search_value: {
          "organizations.project_roles": {
            $in: ["filing applicant", "permit filing representative"],
          },
        },
      },
      {
        name: "Project Owner",
        filter: "owner",
        dropdown_name: "Project Owner",
        search_value: { "organizations.project_roles": { $in: ["owner"] } },
      },
      {
        name: "Architect",
        filter: "architect",
        dropdown_name: "Architect",
        search_value: { "organizations.categories": { $in: ["architect"] } },
      },
      {
        name: "Commercial Broker",
        filter: "commercial-broker",
        dropdown_name: "Commercial Broker",
        search_value: {
          "organizations.categories": { $in: ["commercial broker"] },
        },
      },
      {
        name: "Construction",
        filter: "construction",
        dropdown_name: "Construction",
        search_value: { "organizations.categories": { $in: ["construction"] } },
      },
      {
        name: "Developer",
        filter: "developer",
        dropdown_name: "Developer",
        search_value: { "organizations.categories": { $in: ["developer"] } },
      },
      {
        name: "Engineer",
        filter: "engineer",
        dropdown_name: "Engineer",
        search_value: { "organizations.categories": { $in: ["engineer"] } },
      },
      {
        name: "Expeditor",
        filter: "expeditor",
        dropdown_name: "Expeditor",
        search_value: { "organizations.categories": { $in: ["expeditor"] } },
      },
   /*   {
        name: "Property Manager",
        filter: "property-manager",
        dropdown_name: "Property Manager",
        search_value: {
          "organizations.categories": { $in: ["property-manager"] },
        },
      }, 
      {
        name: "Residential Broker",
        filter: "residential-broker",
        dropdown_name: "Residential Broker",
        search_value: {
          "organizations.categories": { $in: ["residential broker"] },
        },
      }, */
    ],
  },
];
export const _peopleFilters = [
  {
    //"Developer", "Marketing", "Expeditor",  "Engineer", "Architect", "Interior Designer", "Lender", "Construction", "Property Manager","Commercial Broker", "Residential Broker", "Other"
    //"developer", "marketing", "expeditor", "engineer", "architect", "interior designer", "lender", "construction", "commercial broker", "residential broker", "Other"
    name: "Category / Role",
    show_name: true,
    search_key: "contacts.project_roles",
    filter_type: "company",
    multi_filter: true,
    value_contains_key: true,
    values: [
      {
        name: "Any",
        filter: "",
        dropdown_name: "Any",
        search_value: "",
      },
      {
        name: "Permit Applicant",
        filter: "applicant",
        dropdown_name: "Permit Applicant",
        search_value: {
          "contacts.project_roles": { $in: ["applicant", "permit applicant"] },
        },
      },
      {
        name: "Permit Filing Rep",
        filter: "filing-rep",
        dropdown_name: "Permit Filing Rep",
        search_value: {
          "contacts.project_roles": {
            $in: ["filing applicant", "permit filing representative"],
          },
        },
      },
      {
        name: "Project Owner",
        filter: "owner",
        dropdown_name: "Project Owner",
        search_value: { "contacts.project_roles": { $in: ["owner"] } },
      },
      {
        name: "Architect",
        filter: "architect",
        dropdown_name: "Architect",
        search_value: { "contacts.project_roles": { $in: ["architect"] } },
      },
      {
        name: "Commercial Broker",
        filter: "commercial-broker",
        dropdown_name: "Commercial Broker",
        search_value: {
          "contacts.project_roles": { $in: ["commercial broker"] },
        },
      },
      {
        name: "Construction",
        filter: "construction",
        dropdown_name: "Construction",
        search_value: { "contacts.project_roles": { $in: ["construction"] } },
      },
      {
        name: "Developer",
        filter: "developer",
        dropdown_name: "Developer",
        search_value: { "contacts.project_roles": { $in: ["developer"] } },
      },
      {
        name: "Engineer",
        filter: "engineer",
        dropdown_name: "Engineer",
        search_value: { "contacts.project_roles": { $in: ["engineer"] } },
      },
      {
        name: "Expeditor",
        filter: "expeditor",
        dropdown_name: "Expeditor",
        search_value: { "contacts.project_roles": { $in: ["expeditor"] } },
      },
    /*  {
        name: "Property Manager",
        filter: "property-manager",
        dropdown_name: "Property Manager",
        search_value: {
          "contacts.project_roles": { $in: ["property-manager"] },
        },
      },
      {
        name: "Residential Broker",
        filter: "residential-broker",
        dropdown_name: "Residential Broker",
        search_value: {
          "contacts.project_roles": { $in: ["residential broker"] },
        },
      }, */
    ],
  },
];
export const _buildingAdminFilters = [
  {
    name: "Project Type",
    show_name: true,
    search_key: "pipeline_occupancy_type",
    filter_type: "building",
    multi_filter: true,
    value_contains_key: true,
    type: "residential",
    values: [
      {
        name: "Any",
        filter: "",
        dropdown_name: "Any",
        search_value: "",
      },
      {
        name: "Residential",
        filter: "residential",
        dropdown_name: "Residential",
        search_value: {
            "queryString": {
                "defaultPath": "pipeline_occupancy_type",
                "query": "(residential)"
            }
        }
      },
      {
        name: "Commercial",
        filter: "commercial",
        dropdown_name: "Commercial",
        search_value: {
            "queryString": {
                "defaultPath": "pipeline_occupancy_type",
                "query": "(commercial)"
            }
        }
      },
      {
        name: "Institutional",
        filter: "institutional",
        dropdown_name: "Institutional",
        search_value: {
            "queryString": {
                "defaultPath": "pipeline_occupancy_type",
                "query": "(institutional)"
            }
        }
      },
      {
        name: "Mixed-Use",
        filter: "mixed-use",
        dropdown_name: "Mixed-Use",
        search_value: {
            "queryString": {
                "defaultPath": "pipeline_occupancy_type",
                "query": "(mixed-use)"
            }
        }
      }
    ],
  },
  {
    name: "Components",
    show_name: true,
    search_key: "pipeline_project_components",
    filter_type: "building",
    multi_filter: true,
    value_contains_key: true,
    type: "residential",
    values: [
      {
        name: "Any",
        filter: "",
        dropdown_name: "Any",
        search_value: "",
      },
      {
        name: "Condo",
        filter: "condo",
        dropdown_name: "Condo",
        search_value: {
            "queryString": {
                "defaultPath": "pipeline_project_components",
                "query": "(condo OR condominium)"
            }
        }
      },
      {
        name: "Co-op",
        filter: "co-op",
        dropdown_name: "Co-op",
        search_value: {
            "queryString": {
                "defaultPath": "pipeline_project_components",
                "query":"(coop OR co-op OR cooperative)"
            }
        }
      },
      {
        name: "Rental",
        filter: "rental",
        dropdown_name: "Rental",
        search_value: {
            "compound": {
                "should":[
                  {
                    "queryString" : {
                      "defaultPath": "pipeline_project_components",
                      "query":"(rental)"
                    }
                  },
                  {
                    "compound" : {
                     "must" : [
                       {
                         "range" : {
                           "path": "pipeline_dwelling_units_proposed",
                           "gte": 2
                         }
                       },
                       {"queryString": {
                             "defaultPath": "pipeline_occupancy_type",
                             "query": "(residential)"
                         }
                       },
                       {"compound": {
                             "mustNot": {
                              "queryString": {
                                "defaultPath": "pipeline_project_components",
                                "query":"(coop OR co-op OR cooperative OR condo OR condominium OR condop)"
                              }
                            }
                         }
                        }
                       
                     ]
                    }
                  }
                  
                ]
            }
        }
      },
      {
        name: "Single Family",
        filter: "single-family",
        dropdown_name: "Single Family",
        search_value: {
          compound: {
            should: [
              {
                phrase: {
                  query: "(single family)",
                  path: "pipeline_project_components"
                }
              },
              {
                compound: {
                  must: [
                    {
                      range: {
                        path: "pipeline_dwelling_units_proposed",
                        gte: 1,
                        lte: 1
                      }
                    },
                    {
                      compound: {
                        mustNot: [
                          {
                            text: {
                              query: "commercial",
                              path: "pipeline_occupancy_type"
                            }
                          }
                        ]
                      }
                    }
                  ]
                }
              }
            ],
            minimumShouldMatch: 1
          }
        },
      },
      {
        name: "Multi-Family",
        filter: "multi-family",
        dropdown_name: "Multi-Family",
        search_value: {
          compound: {
            must: [
              {
                text: {
                  query: "residential",
                  path: "pipeline_occupancy_type"
                }
              },
              {
                compound: {
                  mustNot: [
                    {
                      text: {
                        query: ["condominium", "cooperative", "condo", "coop", "co-op"],
                        path: "pipeline_project_components"
                      }
                    }
                  ]
                }
              },
              {
                compound: {
                  should: [
                    {
                      text: {
                        query: "multi-family",
                        path: "pipeline_project_components"
                      }
                    },
                    {
                      range: {
                        path: "pipeline_dwelling_units_proposed",
                        gte: 2,
                        lte: 5
                      }
                    }
                  ],
                  minimumShouldMatch: 1
                }
              }
            ]
          }
        }
      },
      {
        name: "Affordable",
        filter: "affordable",
        dropdown_name: "Affordable",
        search_value: {
          compound: {
            should: [
              {
                text: {
                  query: "affordable",
                  path: "pipeline_project_components"
                }
              },
              {
                range: {
                  path: "pipeline_affordable_rental_units_proposed",
                  gt: 0
                }
              },
              {
                range: {
                  path: "pipeline_affordable_condo_units_proposed",
                  gt: 0
                }
              }
            ],
            minimumShouldMatch: 1
          }
        },
      },
      {
        name: "Retail",
        filter: "retail",
        dropdown_name: "Retail",
        search_value: {
          compound: {
          should: [
            {
              text: {
                query: "retail",
                path: "pipeline_project_components"
              }
            },
            {
              compound: {
                must: [
                  {
                    text: {
                      query: ["a2", "m"],
                      path: "pipeline_occupancy_classification_proposed_code"
                    }
                  }
                ]
              }
            }
          ],
          minimumShouldMatch: 1
        }
      }
      },
      {
        name: "Office",
        filter: "office",
        dropdown_name: "Office",
        search_value: {
          compound: {
            should: [
              {
                text: {
                  query: "office",
                  path: "pipeline_project_components"
                }
              },
              {
                compound: {
                  must: [
                    {
                      text: {
                        query: ["b"],
                        path: "pipeline_occupancy_classification_proposed_code"
                      }
                    }
                  ]
                }
              }
            ],
            minimumShouldMatch: 1
          }
        },
      },
      {
        name: "Hotel",
        filter: "hotel",
        dropdown_name: "Hotel",
        search_value: {
          compound: {
            should: [
              {
                text: {
                  query: "hotel",
                  path: "pipeline_project_components"
                }
              },
              {
                compound: {
                  must: [
                    {
                      text: {
                        query: ["r1", "j1"],
                        path: "pipeline_occupancy_classification_proposed_code"
                      }
                    }
                  ]
                }
              }
            ],
            minimumShouldMatch: 1
          }
        },
      },
    ],
  },
  {
    name: "Total Units",
    show_name: true,
    price_filter: true,
    value_contains_key: true,
    filter_key: "pipeline_dwelling_units_proposed",
    search_key: ["min_units", "max_units"],
    labels: ["Min Units", "Max Units"],
    min_max_values: [25, 200],
    min_max_increment: 25,
    custom_min_max_values: {
      min: [1, 11, 31, 51, 101, 201],
      max: [10, 30, 50, 100, 200, 300],
    },
    format_type: "number",
    search_value: [
      "pipeline_dwelling_units_proposed:[{min_units} TO {max_units}]",
    ],
    value_prefix: "",
    title_suffix: "Units"
  },
  {
    name: "Total Floors",
    show_name: true,
    price_filter: true,
    value_contains_key: true,
    filter_key: "pipeline_building_stories_proposed",
    search_key: ["min_floors", "max_floors"],
    labels: ["Min Floors", "Max Floors"],
    min_max_values: [1, 41],
    min_max_increment: 10,
    custom_min_max_values: {
      min: [1, 6, 11, 21, 41],
      max: [5, 10, 20, 40],
    },
    format_type: "number",
    search_value: [
      "pipeline_building_stories_proposed:[{min_floors} TO {max_floors}]",
    ],
    value_prefix: "",
    title_suffix: "Floors"
  },
  {
    name: "Resi Area",
    show_name: true,
    price_filter: true,
    value_contains_key: true,
    filter_key: "pipeline_zoning_area_residential",
    search_key: ["min_sq_ft", "max_sq_ft"],
    labels: ["Min Sq Ft", "Max Sq Ft"],
    min_max_values: [5000, 100000],
    min_max_increment: 500,
    custom_min_max_values: {
      min: [0, 5001, 10001, 25001, 50001, 100001, 250001, 500001, 1000001],
      max: [5000, 10000, 25000, 50000, 100000, 250000, 500000, 500001],
    },
    format_type: "number",
    value_prefix: "",
    title_suffix: "SF",
    type: "residential"
  },
  {
    name: "Comm Area",
    show_name: true,
    price_filter: true,
    value_contains_key: true,
    filter_key: "pipeline_zoning_area_commercial",
    search_key: ["min_comm_sq_ft", "max_comm_sq_ft"],
    labels: ["Min Sq Ft", "Max Sq Ft"],
    min_max_values: [5000, 100000],
    min_max_increment: 500,
    custom_min_max_values: {
      min: [0, 5001, 10001, 25001, 50001, 100001, 250001, 500001, 1000001],
      max: [5000, 10000, 25000, 50000, 100000, 250000, 500000, 500001],
    },
    format_type: "number",
    value_prefix: "",
    title_suffix: "SF",
    type: "residential"
  },
  {
    name: "Total Area",
    show_name: true,
    price_filter: true,
    value_contains_key: true,
    filter_key: "pipeline_total_construction_floor_area",
    search_key: ["min_total_ft", "max_total_ft"],
    labels: ["Min Area", "Max Area"],
    min_max_values: [5000, 100000],
    min_max_increment: 500,
    custom_min_max_values: {
      min: [0, 5001, 10001, 25001, 50001, 100001, 250001, 500001, 1000001],
      max: [5000, 10000, 25000, 50000, 100000, 250000, 500000, 500001],
    },
    format_type: "number",
    value_prefix: "",
    title_suffix: "SF"
  },
  {
    name: "Permit Filed",
    show_name: true,
    exclude_stage: ["pipeline"],
    date_filter: true,
    search_key: ["min_date", "max_date"],
    filter_key: "pipeline_filing_date",
    value_contains_key: true,
    format_type: "date"
  },
  {
    name: "Offering Submitted",
    show_name: true,
    date_filter: true,
    search_key: ["min_offering_date", "max_offering_date"],
    filter_key: "offering_submitted_date",
    value_contains_key: true,
    format_type: "date"
   
  },
  {
    name: "TCO / CO",
    show_name: true,
    multi_filter: true,
    search_key: "pipeline_coo_issuance_date",
    filter_type: "building",
    value_contains_key: true,
    values: [
        {
          name: "Any",
          filter: "",
          dropdown_name: "Any",
          search_value: "",
        },
        {
          name: "No TCO / CO",
          filter: "no-co",
          dropdown_name: "No TCO / CO",
          search_value: {
            compound: {
              must: [
                {
                  compound: {
                    should: [
                      {
                        range: {
                          path: "pipeline_coo_issuance_date",
                          lt: `ISODate:${moment().add(-25, "year").toDate().toISOString()}`
                        }
                      },
                      { compound: {
                          mustNot: [
                            {
                              exists: {
                                path: "pipeline_coo_issuance_date",
                              }
                            }
                          ]
                          }
                      }
                    ],
                    minimumShouldMatch: 1
                  }
                },
                {
                  compound: {
                    mustNot: [
                      {
                        text: {
                          query: "completion",
                          path: "pipeline_project_stage"
                        }
                      }
                    ]
                  }
                }
              ]
            }
          }
        },
        {
          name: "Has TCO / CO",
          filter: "has-co",
          dropdown_name: "Has TCO / CO",
          search_value:{
            compound: {
              must: [
                {
                  range: {
                    path: "pipeline_coo_issuance_date",
                    gte: `ISODate:${moment().add(-25, "year").toDate().toISOString()}`,
                    lte: `ISODate:${moment().toDate().toISOString()}`
                  }
                },
                {
                  text: {
                    query: "completion",
                    path: "pipeline_project_stage"
                  }
                }
              ]
            }
          }
        },
        {
          name: "Within 1 Year",
          filter: "1-year",
          dropdown_name: "Within 1 Year",
          search_value:
                {
                  compound: {
                    must: [
                      {
                        range: {
                          path: "pipeline_coo_issuance_date",
                          gte: `ISODate:${moment().add(-1, "year").toDate().toISOString()}`,
                          lte: `ISODate:${moment().toDate().toISOString()}`
                        }
                      },
                      {
                        text: {
                          query: "completion",
                          path: "pipeline_project_stage"
                        }
                      }
                    ]
                  }
          }
        },
        {
          name: "1 to 2 Years",
          filter: "2-year",
          dropdown_name: "Last 1 to 2 Years",
          search_value: {
            compound: {
              must: [
                {
                  range: {
                    path: "pipeline_coo_issuance_date",
                    gte: `ISODate:${moment().add(-2, "year").toDate().toISOString()}`,
                    lte: `ISODate:${moment().add(-1, "year").toDate().toISOString()}`
                  }
                },
                {
                  text: {
                    query: "completion",
                    path: "pipeline_project_stage"
                  }
                }
              ]
            }
          }
        },
        {
          name: "2 to 5 Years",
          filter: "2-5-year",
          dropdown_name: "Last 2 to 5 Years",
          search_value: {
            compound: {
              must: [
                {
                  range: {
                    path: "pipeline_coo_issuance_date",
                    gte: `ISODate:${moment().add(-5, "year").toDate().toISOString()}`,
                    lte: `ISODate:${moment().add(-2, "year").toDate().toISOString()}`
                  }
                },
                {
                  text: {
                    query: "completion",
                    path: "pipeline_project_stage"
                  }
                }
              ]
            }
          }
        },
        {
          name: "5 to 10 Years",
          filter: "5-10-year",
          dropdown_name: "Last 5 to 10 Years",
          search_value: {
            compound: {
              must: [
                {
                  range: {
                    path: "pipeline_coo_issuance_date",
                    gte: `ISODate:${moment().add(-10, "year").toDate().toISOString()}`,
                    lte: `ISODate:${moment().add(-5, "year").toDate().toISOString()}`
                  }
                },
                {
                  text: {
                    query: "completion",
                    path: "pipeline_project_stage"
                  }
                }
              ]
            }
          }
        },
        {
          name: "10 to 15 Years",
          filter: "10-15-year",
          dropdown_name: "Last 10 to 15 Years",
          search_value: {
            compound: {
              must: [
                {
                  range: {
                    path: "pipeline_coo_issuance_date",
                    gte: `ISODate:${moment().add(-15, "year").toDate().toISOString()}`,
                    lte: `ISODate:${moment().add(-10, "year").toDate().toISOString()}`
                  }
                },
                {
                  text: {
                    query: "completion",
                    path: "pipeline_project_stage"
                  }
                }
              ]
            }
          }
        },
        {
          name: "More Than 15 Years",
          filter: "more-15-year",
          dropdown_name: "More Than 15 Years Ago",
          search_value: {
            compound: {
              must: [
                {
                  range: {
                    path: "pipeline_coo_issuance_date",
                    lte: `ISODate:${moment().add(-15, "year").toDate().toISOString()}`,
                  }
                },
                {
                  text: {
                    query: "completion",
                    path: "pipeline_project_stage"
                  }
                }
              ]
            }
          }
        },
      ],
   
  },
  {
    name: "Tax Benefits",
    show_name: true,
    search_key: "tax_benefits",
    multi_filter : true,
    value_contains_key: true,
    values: [
      
      {
        name: "421a",
        filter: "421a",
        dropdown_name: "421a",
        search_value: {
          equals: {
            value: true,
            path: "tax_abatement_program_421a"
          }
        },
      },
      {
        name: "J51",
        filter: "j51",
        dropdown_name: "J51",
        search_value: {
          equals: {
            value: true,
            path: "tax_abatement_program_j51"
          }
        }
      }
      
    ]
  },
  {
    name: "Construction Type",
    show_name: true,
    search_key: "pipeline_construction_type",
    filter_type: "building",
    multi_filter: true,
    value_contains_key: true,
    type: "residential",
    values: [
      {
        name: "Any",
        filter: "",
        dropdown_name: "Any",
        search_value: "",
      },
      {
        name: "New Construction",
        filter: "new-construction",
        dropdown_name: "New Construction",
        search_value: {
          compound: {
            should: [
              {
                text: {
                  query: "new-construction",
                  path: "construction_type.pipeline_construction_type"
                }
              },
              {
                compound: {
                  must: [
                    {
                      text: {
                        query: "nb",
                        path: "pipeline_job_type"
                      }
                    },
                    
                  ],
                  mustNot:[
                    {
                      exists: {
                        path: "construction_type.pipeline_construction_type"
                      }
                    }
                  ]
                }
              }
            ],
            minimumShouldMatch: 1
          }
        },
      },
      {
        name: "Alteration",
        filter: "alteration",
        dropdown_name: "Alteration",
        search_value: {
          compound: {
            should: [
              {
                text: {
                  query: "alteration",
                  path: "construction_type.pipeline_construction_type"
                }
              },
              {
                compound: {
                  must: [
                    {
                      text: {
                        query: "a1",
                        path: "pipeline_job_type"
                      }
                    },
                  ],
                  mustNot:[
                    {
                      exists: {
                        path: "construction_type.pipeline_construction_type"
                      }
                    }
                  ]
                }
              },
              {
                text: {
                  query: ["Office to Condo", "Office to Rental", "Office to Residential"],
                  path: "custom_fields.Value"
                }
              }
            ],
            minimumShouldMatch: 1
          }
        }
      },
     
      {
        name: "Office to Residential",
        filter: "office-to-resi",
        dropdown_name: "Office to Residential",
        search_value: {
          compound: {
            should: [
              {
                phrase: {
                  query: ["Office to Condo", "Office to Rental", "Office to Residential"],
                  path: "custom_fields.Value"
                }
              }
            ],
            minimumShouldMatch: 1
          }
        },
      },
      {
        name: "Office to Condo",
        filter: "office-to-condo",
        dropdown_name: "Office to Condo",
        search_value: {
          compound: {
            should: [
              {
                phrase: {
                  query: "Office to Condo",
                  path: "custom_fields.Value"
                }
              }
            ],
            minimumShouldMatch: 1
          }
        }
      },
      {
        name: "Office to Rental",
        filter: "office-to-rental",
        dropdown_name: "Office to Rental",
        search_value: {
          compound: {
            should: [
              {
                phrase: {
                  query: ["Office to Rental"],
                  path: "custom_fields.Value"
                }
              }
            ],
            minimumShouldMatch: 1
          }
        }
      },
      {
        name: "Rental to Condo",
        filter: "rental-to-condo",
        dropdown_name: "Rental to Condo",
        search_value: {
          compound: {
            should: [
              {
                phrase: {
                  query: ["Rental to Condo"],
                  path: "custom_fields.Value"
                }
              }
            ],
            minimumShouldMatch: 1
          }
        }
      }
    ],
  },
  {
    name: "Project Progress",
    show_name: true,
    search_key: "project_progress",
    filter_type: "building",
    multi_filter: true,
    value_contains_key: true,
    type: "residential",
    values: [
      {
        name: "Any",
        filter: "",
        dropdown_name: "Any",
        search_value: "",
      },
      {
        name: "Active",
        filter: "active",
        dropdown_name: "Active",
        search_value: {
          compound: {
           
            mustNot:[
              {
                exists: {
                  path: "pipeline_project_stalled"
                }
              },
              {
                exists: {
                  path: "pipeline_project_abandoned"
                }
              }
            ],
          }
        }
      },
      {
        name: "Stalled",
        filter: "stalled",
        dropdown_name: "Stalled",
        search_value: { 
          equals: {
            path: "pipeline_project_stalled",
            value: true
          }
        },
      },
      {
        name: "Abandoned",
        filter: "abandoned",
        dropdown_name: "Abandoned",
        search_value: { 
          equals: {
            path: "pipeline_project_abandoned",
            value: true
          }
        }
      }
    ],
  },
];

export const _buildingAdminMatchFilters = [
	{
	  name: "Project Type",
	  show_name: true,
	  search_key: "pipeline_occupancy_type",
	  filter_type: "building",
	  multi_filter: true,
	  value_contains_key: true,
	  type: "residential",
	  values: [
		{
		  name: "Any",
		  filter: "",
		  dropdown_name: "Any",
		  search_value: "",
		},
		{
		  name: "Residential",
		  filter: "residential",
		  dropdown_name: "Residential",
		  search_value: { pipeline_occupancy_type: { $in: ["residential"] } },
		},
		{
		  name: "Commercial",
		  filter: "commercial",
		  dropdown_name: "Commercial",
		  search_value: { pipeline_occupancy_type: { $in: ["commercial"] } },
		},
		{
		  name: "Institutional",
		  filter: "institutional",
		  dropdown_name: "Institutional",
		  search_value: { pipeline_occupancy_type: { $in: ["institutional"] } },
		},
		{
		  name: "Mixed-Use",
		  filter: "mixed-use",
		  dropdown_name: "Mixed-Use",
		  search_value: { pipeline_occupancy_type: { $in: ["mixed-use"] } },
		}
	  ],
	},
	{
	  name: "Components",
	  show_name: true,
	  search_key: "pipeline_project_components",
	  filter_type: "building",
	  multi_filter: true,
	  value_contains_key: true,
	  type: "residential",
	  values: [
		{
		  name: "Any",
		  filter: "",
		  dropdown_name: "Any",
		  search_value: "",
		},
		{
		  name: "Condo",
		  filter: "condo",
		  dropdown_name: "Condo",
		  search_value: {
			pipeline_project_components: { $in: ["condo", "condominium"] },
		  },
		},
		{
		  name: "Co-op",
		  filter: "co-op",
		  dropdown_name: "Co-op",
		  search_value: {
			pipeline_project_components: {
			  $in: ["coop", "co-op", "cooperative"],
			},
		  },
		},
		{
		  name: "Rental",
		  filter: "rental",
		  dropdown_name: "Rental",
		  search_value: {
			$or: [
			  { pipeline_project_components: { $in: ["rental"] } },
			  { $and : [
				  {pipeline_dwelling_units_proposed: { $gte: 2 } }, 
				  {pipeline_occupancy_type: {$nin : ["commercial"]}}, 
				  {pipeline_project_components: {
				  $nin: ["coop", "co-op", "cooperative", "condo", "condominium", "condop"],
				  }}]
			  }
			],
		  },
		},
		{
		  name: "Single Family",
		  filter: "single-family",
		  dropdown_name: "Single Family",
		  search_value: {
			$or: [
			  { pipeline_project_components: { $in: ["single family"] } },
			  { $and : [{pipeline_dwelling_units_proposed: 1 }, {pipeline_occupancy_type: {$nin : ["commercial"]}}]}
			],
		  },
		},
		{
		  name: "Multi-Family",
		  filter: "multi-family",
		  dropdown_name: "Multi-Family",
		  search_value: {
			$and: [
			  { pipeline_occupancy_type: { $in: ["residential"] } },
			  {
				pipeline_project_components: {
				  $nin: ["condominium", "cooperative", "condo", "coop", "co-op"],
				},
			  },
			  {
				$or: [
				  { pipeline_project_components: { $in: ["multi-family"] } },
				  { pipeline_dwelling_units_proposed: { $gte: 2, $lte: 5 } },
				],
			  },
			],
		  },
		},
		{
		  name: "Affordable",
		  filter: "affordable",
		  dropdown_name: "Affordable",
		  search_value: {
			$or: [
			  { pipeline_project_components: { $in: ["affordable"] } },
			  { pipeline_affordable_rental_units_proposed: { $gt: 0 } },
			  { pipeline_affordable_condo_units_proposed: { $gt: 0 } },
			],
		  },
		},
		{
		  name: "Retail",
		  filter: "retail",
		  dropdown_name: "Retail",
		  search_value: {
			$or: [
			  { pipeline_project_components: { $in: ["retail"] } },
			  {
				"$and" : [ {pipeline_occupancy_classification_proposed_code: { $in: ["a2", "m"]} }, { "occupancy_type.Project Components" : { "$exists" : false } }  ]
			  },
			],
		  },
		},
		{
		  name: "Office",
		  filter: "office",
		  dropdown_name: "Office",
		  search_value: {
			$or: [
			  { pipeline_project_components: { $in: ["office"] } },
			  {
				"$and" : [ { pipeline_occupancy_classification_proposed_code: { $in: ["b"] } }, { "occupancy_type.Project Components" : { "$exists" : false } }  ]
			  },
			],
		  },
		},
		{
		  name: "Hotel",
		  filter: "hotel",
		  dropdown_name: "Hotel",
		  search_value: {
			$or: [
			  { pipeline_project_components: { $in: ["hotel"] } },
			  {
				"$and" : [ {pipeline_occupancy_classification_proposed_code: { $in: ["r1", "j1"]} }, { "occupancy_type.Project Components" : { "$exists" : false } }  ]
			  },
			],
		  },
		},
	  ],
	},
	{
	  name: "Total Units",
	  show_name: true,
	  price_filter: true,
	  value_contains_key: true,
	  filter_key: "pipeline_dwelling_units_proposed",
	  search_key: ["min_units", "max_units"],
	  labels: ["Min Units", "Max Units"],
	  min_max_values: [25, 200],
	  min_max_increment: 25,
	  custom_min_max_values: {
		min: [1, 11, 31, 51, 101, 201],
		max: [10, 30, 50, 100, 200, 300],
	  },
	  format_type: "number",
	  search_value: [
		"pipeline_dwelling_units_proposed:[{min_units} TO {max_units}]",
	  ],
	  value_prefix: "",
	  title_suffix: "Units",
	  values: [
		{
		  name: "Any Units",
		  filter: "",
		  dropdown_name: "Any",
		  search_value: "",
		},
		{
		  name: "1-10 Total Units",
		  filter: "1-to-10",
		  dropdown_name: "1 to 10 Units",
		  search_value: { $gte: 1, $lte: 10 },
		},
  
		{
		  name: "11-30 Total Units",
		  filter: "11-to-30",
		  dropdown_name: "11 to 30 Units",
		  search_value: { $gte: 11, $lte: 30 },
		},
		{
		  name: "31-50 Total Units",
		  filter: "31-to-50",
		  dropdown_name: "31 to 50 Units",
		  search_value: { $gte: 31, $lte: 50 },
		},
		{
		  name: "51-100 Total Units",
		  filter: "51-to-100",
		  dropdown_name: "51 to 100 Units",
		  search_value: { $gte: 51, $lte: 100 },
		},
		{
		  name: "101-200 Total Units",
		  filter: "101-to-200",
		  dropdown_name: "101 to 200 Units",
		  search_value: { $gte: 101, $lte: 200 },
		},
		{
		  name: "201 + Total Units",
		  filter: "201-or-more",
		  dropdown_name: "201 or more Units",
		  search_value: { $gte: 201 },
		},
	  ],
	},
	{
	  name: "Total Floors",
	  show_name: true,
	  price_filter: true,
	  value_contains_key: true,
	  filter_key: "pipeline_building_stories_proposed",
	  search_key: ["min_floors", "max_floors"],
	  labels: ["Min Floors", "Max Floors"],
	  min_max_values: [1, 41],
	  min_max_increment: 10,
	  custom_min_max_values: {
		min: [1, 6, 11, 21, 41],
		max: [5, 10, 20, 40],
	  },
	  format_type: "number",
	  search_value: [
		"pipeline_building_stories_proposed:[{min_floors} TO {max_floors}]",
	  ],
	  value_prefix: "",
	  title_suffix: "Floors",
	  values: [
		{
		  name: "Any Units",
		  filter: "",
		  dropdown_name: "Any",
		  search_value: "",
		},
		{
		  name: "1-5 Floors",
		  filter: "1-to-5",
		  dropdown_name: "1 to 5 Floors",
		  search_value: { $gte: 1, $lte: 5 },
		},
		{
		  name: "6-10 Floors",
		  filter: "6-to-10",
		  dropdown_name: "6 to 10 Floors",
		  search_value: { $gte: 6, $lte: 10 },
		},
		{
		  name: "11-20 Floors",
		  filter: "11-to-20",
		  dropdown_name: "11 to 20 Floors",
		  search_value: { $gte: 11, $lte: 20 },
		},
		{
		  name: "21-40 Floors",
		  filter: "21-to-40",
		  dropdown_name: "21 to 40 Floors",
		  search_value: { $gte: 21, $lte: 40 },
		},
  
		{
		  name: "41+ Floors",
		  filter: "41-or-more",
		  dropdown_name: "41+ Floors",
		  search_value: { $gte: 41 },
		},
	  ],
	},
	{
	  name: "Resi Area",
	  show_name: true,
	  price_filter: true,
	  value_contains_key: true,
	  filter_key: "pipeline_zoning_area_residential",
	  search_key: ["min_sq_ft", "max_sq_ft"],
	  labels: ["Min Sq Ft", "Max Sq Ft"],
	  min_max_values: [5000, 100000],
	  min_max_increment: 500,
	  custom_min_max_values: {
		min: [0, 5001, 10001, 25001, 50001, 100001, 250001, 500001, 1000001],
		max: [5000, 10000, 25000, 50000, 100000, 250000, 500000, 500001],
	  },
	  format_type: "number",
	  value_prefix: "",
	  title_suffix: "SF",
	  type: "residential",
	  values: [
		{
		  name: "Any",
		  filter: "",
		  dropdown_name: "Any",
		  search_value: "",
		},
		{
		  name: "25,000 or More SF",
		  filter: "25-and-more",
		  dropdown_name: "25,000 or More SF",
		  search_value: { $gte: 25000 },
		},
		{
		  name: "5,000 SF or Less",
		  filter: "1",
		  dropdown_name: "5,000 SF or Less",
		  search_value: { $lte: 5000 },
		},
		{
		  name: "5,001 - 10,000 SF",
		  filter: "5-to-10",
		  dropdown_name: "5,001 - 10,000 SF",
		  search_value: { $gte: 5001, $lte: 10000 },
		},
		{
		  name: "10,001 - 25,000 SF",
		  filter: "10-to-25",
		  dropdown_name: "10,001 - 25,000 SF",
		  search_value: { $gte: 10001, $lte: 25000 },
		},
		{
		  name: "25,001 - 50,000 SF",
		  filter: "25-to-50",
		  dropdown_name: "25,001 - 50,000 SF",
		  search_value: { $gte: 25001, $lte: 50000 },
		},
		{
		  name: "50,001 - 100,000 SF",
		  filter: "50-to-100",
		  dropdown_name: "50,001 - 100,000 SF",
		  search_value: { $gte: 50001, $lte: 100000 },
		},
		{
		  name: "100,001 - 250,000 SF",
		  filter: "100-to-250",
		  dropdown_name: "100,001 - 250,000 SF",
		  search_value: { $gte: 100001, $lte: 250000 },
		},
		{
		  name: "250,001 - 500,000 SF",
		  filter: "250-to-500",
		  dropdown_name: "250,001 - 500,000 SF",
		  search_value: { $gte: 250001, $lte: 500000 },
		},
		{
		  name: "500,001 - 1M SF",
		  filter: "500-to-1m",
		  dropdown_name: "500,001 - 1M SF",
		  search_value: { $gte: 500001, $lte: 1000000 },
		},
		{
		  name: "More Than 1M SF",
		  filter: "1m-and-more",
		  dropdown_name: "More Than 1M SF",
		  search_value: { $gte: 1000001 },
		},
	  ],
	},
	{
	  name: "Comm Area",
	  show_name: true,
	  price_filter: true,
	  value_contains_key: true,
	  filter_key: "pipeline_zoning_area_commercial",
	  search_key: ["min_comm_sq_ft", "max_comm_sq_ft"],
	  labels: ["Min Sq Ft", "Max Sq Ft"],
	  min_max_values: [5000, 100000],
	  min_max_increment: 500,
	  custom_min_max_values: {
		min: [0, 5001, 10001, 25001, 50001, 100001, 250001, 500001, 1000001],
		max: [5000, 10000, 25000, 50000, 100000, 250000, 500000, 500001],
	  },
	  format_type: "number",
	  value_prefix: "",
	  title_suffix: "SF",
	  type: "residential",
	  values: [
		{
		  name: "Any",
		  filter: "",
		  dropdown_name: "Any",
		  search_value: "",
		},
		{
		  name: "25,000 or More SF",
		  filter: "25-and-more",
		  dropdown_name: "25,000 or More SF",
		  search_value: { $gte: 25000 },
		},
		{
		  name: "5,000 SF or Less",
		  filter: "1",
		  dropdown_name: "5,000 SF or Less",
		  search_value: { $lte: 5000 },
		},
		{
		  name: "5,001 - 10,000 SF",
		  filter: "5-to-10",
		  dropdown_name: "5,001 - 10,000 SF",
		  search_value: { $gte: 5001, $lte: 10000 },
		},
		{
		  name: "10,001 - 25,000 SF",
		  filter: "10-to-25",
		  dropdown_name: "10,001 - 25,000 SF",
		  search_value: { $gte: 10001, $lte: 25000 },
		},
		{
		  name: "25,001 - 50,000 SF",
		  filter: "25-to-50",
		  dropdown_name: "25,001 - 50,000 SF",
		  search_value: { $gte: 25001, $lte: 50000 },
		},
		{
		  name: "50,001 - 100,000 SF",
		  filter: "50-to-100",
		  dropdown_name: "50,001 - 100,000 SF",
		  search_value: { $gte: 50001, $lte: 100000 },
		},
		{
		  name: "100,001 - 250,000 SF",
		  filter: "100-to-250",
		  dropdown_name: "100,001 - 250,000 SF",
		  search_value: { $gte: 100001, $lte: 250000 },
		},
		{
		  name: "250,001 - 500,000 SF",
		  filter: "250-to-500",
		  dropdown_name: "250,001 - 500,000 SF",
		  search_value: { $gte: 250001, $lte: 500000 },
		},
		{
		  name: "500,001 - 1M SF",
		  filter: "500-to-1m",
		  dropdown_name: "500,001 - 1M SF",
		  search_value: { $gte: 500001, $lte: 1000000 },
		},
		{
		  name: "More Than 1M SF",
		  filter: "1m-and-more",
		  dropdown_name: "More Than 1M SF",
		  search_value: { $gte: 1000001 },
		},
	  ],
	},
	{
	  name: "Total Area",
	  show_name: true,
	  price_filter: true,
	  value_contains_key: true,
	  filter_key: "pipeline_total_construction_floor_area",
	  search_key: ["min_total_ft", "max_total_ft"],
	  labels: ["Min Area", "Max Area"],
	  min_max_values: [5000, 100000],
	  min_max_increment: 500,
	  custom_min_max_values: {
		min: [0, 5001, 10001, 25001, 50001, 100001, 250001, 500001, 1000001],
		max: [5000, 10000, 25000, 50000, 100000, 250000, 500000, 500001],
	  },
	  format_type: "number",
	  value_prefix: "",
	  title_suffix: "SF",
	  values: [
		{
		  name: "25,000 or More SF",
		  filter: "25-and-more",
		  dropdown_name: "25,000 or More SF",
		  search_value: { $gte: 25000 },
		},
		{
		  name: "5,000 SF or Less",
		  filter: "1",
		  dropdown_name: "5,000 SF or Less",
		  search_value: { $lte: 5000 },
		},
		{
		  name: "5,001 - 10,000 SF",
		  filter: "5-to-10",
		  dropdown_name: "5,001 - 10,000 SF",
		  search_value: { $gte: 5001, $lte: 10000 },
		},
		{
		  name: "10,001 - 25,000 SF",
		  filter: "10-to-25",
		  dropdown_name: "10,001 - 25,000 SF",
		  search_value: { $gte: 10001, $lte: 25000 },
		},
		{
		  name: "25,001 - 50,000 SF",
		  filter: "25-to-50",
		  dropdown_name: "25,001 - 50,000 SF",
		  search_value: { $gte: 25001, $lte: 50000 },
		},
		{
		  name: "50,001 - 100,000 SF",
		  filter: "50-to-100",
		  dropdown_name: "50,001 - 100,000 SF",
		  search_value: { $gte: 50001, $lte: 100000 },
		},
		{
		  name: "100,001 - 250,000 SF",
		  filter: "100-to-250",
		  dropdown_name: "100,001 - 250,000 SF",
		  search_value: { $gte: 100001, $lte: 250000 },
		},
		{
		  name: "250,001 - 500,000 SF",
		  filter: "250-to-500",
		  dropdown_name: "250,001 - 500,000 SF",
		  search_value: { $gte: 250001, $lte: 500000 },
		},
		{
		  name: "500,001 - 1M SF",
		  filter: "500-to-1m",
		  dropdown_name: "500,001 - 1M SF",
		  search_value: { $gte: 500001, $lte: 1000000 },
		},
		{
		  name: "More Than 1M SF",
		  filter: "1m-and-more",
		  dropdown_name: "More Than 1M SF",
		  search_value: { $gte: 1000001 },
		},
	  ],
	},
	{
	  name: "Permit Filed",
	  show_name: true,
	  exclude_stage: ["pipeline"],
	  date_filter: true,
	  search_key: ["min_date", "max_date"],
	  filter_key: "pipeline_filing_date",
	  value_contains_key: true,
	  format_type: "date",
	  values: [
		{
		  name: "Any",
		  filter: "",
		  dropdown_name: "Any",
		  search_value: "",
		},
		{
		  name: "Not Started",
		  filter: "not-started",
		  dropdown_name: "Not Started",
		  search_value: { $exists: false },
		},
		{
		  name: "Has Started",
		  filter: "has-started",
		  dropdown_name: "Has Started",
		  search_value: {
			$gte: moment().add(-25, "year").toDate().toISOString(),
			$lte: moment().toDate().toISOString(),
		  },
		},
		{
		  name: "Within 1 Year",
		  filter: "1-year",
		  dropdown_name: "Within 1 Year",
		  search_value: {
			$gte: moment().add(-1, "year").toDate().toISOString(),
			$lte: moment().toDate().toISOString(),
		  },
		},
		{
		  name: "1 to 2 Years",
		  filter: "2-year",
		  dropdown_name: "Last 1 to 2 Years",
		  search_value: {
			$gte: moment().add(-2, "year").toDate().toISOString(),
			$lte: moment().toDate().toISOString(),
		  },
		},
		{
		  name: "2 to 5 Years",
		  filter: "2-5-year",
		  dropdown_name: "Last 2 to 5 Years",
		  search_value: {
			$gte: moment().add(-5, "year").toDate().toISOString(),
			$lte: moment().add(-2, "year").toDate().toISOString(),
		  },
		},
		{
		  name: "5 to 10 Years",
		  filter: "5-10-year",
		  dropdown_name: "Last 5 to 10 Years",
		  search_value: {
			$gte: moment().add(-10, "year").toDate().toISOString(),
			$lte: moment().add(-5, "year").toDate().toISOString(),
		  },
		},
		{
		  name: "10 to 15 Years",
		  filter: "10-15-year",
		  dropdown_name: "Last 10 to 15 Years",
		  search_value: {
			$gte: moment().add(-15, "year").toDate().toISOString(),
			$lte: moment().add(-10, "year").toDate().toISOString(),
		  },
		},
		{
		  name: "More Than 15 Years",
		  filter: "more-15-year",
		  dropdown_name: "More Than 15 Years Ago",
		  search_value: {
			$gte: moment().add(-20, "year").toDate().toISOString(),
			$lte: moment().add(-15, "year").toDate().toISOString(),
		  },
		},
	  ],
	},
	{
	  name: "Offering Submitted",
	  show_name: true,
	  multi_filter: true,
	  search_key: "offering_submitted_date",
	  filter_type: "building",
	  multi_filter: true,
	  value_contains_key: true,
	  values: [
		  {
			name: "Any",
			filter: "",
			dropdown_name: "Any",
			search_value: "",
		  },
		  {
			name: "No Offering Plan",
			filter: "no-offering",
			dropdown_name: "No Offering Plan",
			search_value: {            
				$or : [ 
				{"offering_submitted_date" : { $lt: `ISODate:${moment().add(-25, "year").toDate().toISOString()}`}},
				{"offering_submitted_date" : { $exists: false }}
			  ] 
			},
		  },
		  {
			name: "Has Offering Plan",
			filter: "has-offering",
			dropdown_name: "Has Offering Plan",
			search_value: {            
				$and : [ 
				{"offering_submitted_date" : { $gte: `ISODate:${moment().add(-25, "year").toDate().toISOString()}`}}, 
				{"offering_submitted_date" : { $lte: `ISODate:${moment().toDate().toISOString()}`}},
				{"offering_file_number" : { $exists: true }}
			  ] 
			},
		  },
		  {
			name: "Within 1 Year",
			filter: "1-year",
			dropdown_name: "Within 1 Year",
			search_value: {            
				$and : [ 
				{"offering_submitted_date" : { $gte: `ISODate:${moment().add(-1, "year").toDate().toISOString()}`}}, 
				{"offering_submitted_date" : { $lte: `ISODate:${moment().toDate().toISOString()}`}},
				{"offering_file_number" : { $exists: true }}
			  ] 
			},
		  },
		  {
			name: "1 to 2 Years",
			filter: "2-year",
			dropdown_name: "Last 1 to 2 Years",
			search_value: {            
				$and : [ 
				{"offering_submitted_date" : { $gte: `ISODate:${moment().add(-2, "year").toDate().toISOString()}`}}, 
				{"offering_submitted_date" : { $lte: `ISODate:${moment().add(-1, "year").toDate().toISOString()}`}},
				{"offering_file_number" : { $exists: true }}
			  ] 
			}
		  },
		  {
			name: "2 to 5 Years",
			filter: "2-5-year",
			dropdown_name: "Last 2 to 5 Years",
			search_value: {            
				$and : [ 
				{"offering_submitted_date" : { $gte: `ISODate:${moment().add(-5, "year").toDate().toISOString()}`}}, 
				{"offering_submitted_date" : { $lte: `ISODate:${moment().add(-2, "year").toDate().toISOString()}`}},
				{"offering_file_number" : { $exists: true }}
			  ] 
			}
		  },
		  {
			name: "5 to 10 Years",
			filter: "5-10-year",
			dropdown_name: "Last 5 to 10 Years",
			search_value: {            
				$and : [ 
				{"offering_submitted_date" : { $gte: `ISODate:${moment().add(-10, "year").toDate().toISOString()}`}}, 
				{"offering_submitted_date" : { $lte: `ISODate:${moment().add(-5, "year").toDate().toISOString()}`}},
				{"offering_file_number" : { $exists: true }}
			  ] 
			}
		  },
		  {
			name: "10 to 15 Years",
			filter: "10-15-year",
			dropdown_name: "Last 10 to 15 Years",
			search_value: {            
				$and : [ 
				{"offering_submitted_date" : { $gte: `ISODate:${moment().add(-15, "year").toDate().toISOString()}`}}, 
				{"offering_submitted_date" : { $lte: `ISODate:${moment().add(-10, "year").toDate().toISOString()}`}},
				{"offering_file_number" : { $exists: true }}
			  ] 
			}
		  },
		  {
			name: "More Than 15 Years",
			filter: "more-15-year",
			dropdown_name: "More Than 15 Years Ago",
			search_value: {            
				$and : [ 
				{"offering_submitted_date" : { $gte: `ISODate:${moment().add(-15, "year").toDate().toISOString()}`}}, 
				{"offering_submitted_date" : { $lte: `ISODate:${moment().add(-15, "year").toDate().toISOString()}`}},
				{"offering_file_number" : { $exists: true }},
				{"offering_file_number" : { $ne: "" }}
			  ] 
			}
		  },
		],
	 
	},
	{
	  name: "TCO / CO",
	  show_name: true,
	  multi_filter: true,
	  search_key: "pipeline_coo_issuance_date",
	  filter_type: "building",
	  value_contains_key: true,
	  values: [
		  {
			name: "Any",
			filter: "",
			dropdown_name: "Any",
			search_value: "",
		  },
		  {
			name: "No TCO / CO",
			filter: "no-co",
			dropdown_name: "No TCO / CO",
			search_value: {   
			   $and : [          
				{ $or : [ 
				  {"pipeline_coo_issuance_date" : { $lt: `ISODate:${moment().add(-25, "year").toDate().toISOString()}`}},
				  {"pipeline_coo_issuance_date" : { $exists: false }},
				]},
				{"pipeline_project_stage" : {"$ne" : "completion"}}
			  ]
			},
		  },
		  {
			name: "Has TCO / CO",
			filter: "has-co",
			dropdown_name: "Has TCO / CO",
			search_value: {   
			  $or : [         
				{ $and : [ 
				{"pipeline_coo_issuance_date" : { $gte: `ISODate:${moment().add(-25, "year").toDate().toISOString()}`}}, 
				{"pipeline_coo_issuance_date" : { $lte: `ISODate:${moment().toDate().toISOString()}`}} ,
			   
			  ]},
			  {"pipeline_project_stage" : "completion"}
			  ] 
			},
		  },
		  {
			name: "Within 1 Year",
			filter: "1-year",
			dropdown_name: "Within 1 Year",
			search_value: {            
				$and : [ 
				{"pipeline_coo_issuance_date" : { $gte: `ISODate:${moment().add(-1, "year").toDate().toISOString()}`}}, 
				{"pipeline_coo_issuance_date" : { $lte: `ISODate:${moment().toDate().toISOString()}`}},
				{"pipeline_project_stage" : "completion"}
			  ] 
			},
		  },
		  {
			name: "1 to 2 Years",
			filter: "2-year",
			dropdown_name: "Last 1 to 2 Years",
			search_value: {            
				$and : [ 
				{"pipeline_coo_issuance_date" : { $gte: `ISODate:${moment().add(-2, "year").toDate().toISOString()}`}}, 
				{"pipeline_coo_issuance_date" : { $lte: `ISODate:${moment().add(-1, "year").toDate().toISOString()}`}},
				{"pipeline_project_stage" : "completion"}
			  ] 
			}
		  },
		  {
			name: "2 to 5 Years",
			filter: "2-5-year",
			dropdown_name: "Last 2 to 5 Years",
			search_value: {            
				$and : [ 
				{"pipeline_coo_issuance_date" : { $gte: `ISODate:${moment().add(-5, "year").toDate().toISOString()}`}}, 
				{"pipeline_coo_issuance_date" : { $lte: `ISODate:${moment().add(-2, "year").toDate().toISOString()}`}},
				{"pipeline_project_stage" : "completion"}
			  ] 
			}
		  },
		  {
			name: "5 to 10 Years",
			filter: "5-10-year",
			dropdown_name: "Last 5 to 10 Years",
			search_value: {            
				$and : [ 
				{"pipeline_coo_issuance_date" : { $gte: `ISODate:${moment().add(-10, "year").toDate().toISOString()}`}}, 
				{"pipeline_coo_issuance_date" : { $lte: `ISODate:${moment().add(-5, "year").toDate().toISOString()}`}},
				{"pipeline_project_stage" : "completion"}
			  ] 
			}
		  },
		  {
			name: "10 to 15 Years",
			filter: "10-15-year",
			dropdown_name: "Last 10 to 15 Years",
			search_value: {            
				$and : [ 
				{"offering_submitted_date" : { $gte: `ISODate:${moment().add(-15, "year").toDate().toISOString()}`}}, 
				{"offering_submitted_date" : { $lte: `ISODate:${moment().add(-10, "year").toDate().toISOString()}`}},
				{"pipeline_project_stage" : "completion"}
			  ] 
			}
		  },
		  {
			name: "More Than 15 Years",
			filter: "more-15-year",
			dropdown_name: "More Than 15 Years Ago",
			search_value: {            
				$and : [ 
				{"offering_submitted_date" : { $gte: `ISODate:${moment().add(-15, "year").toDate().toISOString()}`}}, 
				{"offering_submitted_date" : { $lte: `ISODate:${moment().add(-15, "year").toDate().toISOString()}`}},
				{"pipeline_project_stage" : "completion"}
			  ] 
			}
		  },
		],
	 
	},
	{
	  name: "Tax Benefits",
	  show_name: true,
	  search_key: "tax_benefits",
	  filter_type: "building",
	  multi_filter : true,
	  value_contains_key: true,
	  values: [
		{
		  name: "421a",
		  filter: "421a",
		  dropdown_name: "421a",
		  search_value: {$and:[{tax_abatement_program_421a:true}]},
		},
		{
		  name: "J51",
		  filter: "j51",
		  dropdown_name: "J51",
		  search_value: {$and:[{tax_abatement_program_j51:true}]},
		}
	  ]
	},
	{
	  name: "Construction Type",
	  show_name: true,
	  search_key: "pipeline_construction_type",
	  filter_type: "building",
	  multi_filter: true,
	  value_contains_key: true,
	  type: "residential",
	  values: [
		{
		  name: "Any",
		  filter: "",
		  dropdown_name: "Any",
		  search_value: "",
		},
		{
		  name: "New Construction",
		  filter: "new-construction",
		  dropdown_name: "New Construction",
		  search_value: { 
			$or: [
			  { "construction_type.pipeline_construction_type": { $in: ["new-construction"] } },
			  {
				"$and" : [ { pipeline_job_type: { $in: ["nb"] } }, { "construction_type.pipeline_construction_type" : { "$exists" : false } }  ]
			  },
			] 
		  },
		},
		{
		  name: "Alteration",
		  filter: "alteration",
		  dropdown_name: "Alteration",
		  search_value: { 
			$or: [
			  { "construction_type.pipeline_construction_type": { $in: ["alteration"] } },
			  {
				"$and" : [ { pipeline_job_type: { $in: ["a1"] } }, { "construction_type.pipeline_construction_type" : { "$exists" : false } }  ]
			  },
			  { "custom_fields.Value": { $in: ["Office to Condo", "Office to Rental",  "Office to Residential"] } }
			] 
		   },
		},
	   
		{
		  name: "Office to Residential",
		  filter: "office-to-resi",
		  dropdown_name: "Office to Residential",
		  search_value: { 
			$or: [
			  { "custom_fields.Value": { $in: ["Office to Condo", "Office to Rental",  "Office to Residential"] } }
			] 
		   },
		},
		{
		  name: "Office to Condo",
		  filter: "office-to-condo",
		  dropdown_name: "Office to Condo",
		  search_value: { 
			$or: [
			  { "custom_fields.Value": { $in: ["Office to Condo"] } }
			] 
		   },
		},
		{
		  name: "Office to Rental",
		  filter: "office-to-rental",
		  dropdown_name: "Office to Rental",
		  search_value: { 
			$or: [
			  { "custom_fields.Value": { $in: ["Office to Rental"] } }
			] 
		   },
		}
	  ],
	},
	{
	  name: "Project Progress",
	  show_name: true,
	  search_key: "project_progress",
	  filter_type: "building",
	  multi_filter: true,
	  value_contains_key: true,
	  type: "residential",
	  values: [
		{
		  name: "Any",
		  filter: "",
		  dropdown_name: "Any",
		  search_value: "",
		},
		{
		  name: "Active",
		  filter: "active",
		  dropdown_name: "Active",
		  search_value: { 
			$and: [
			  { "$or" : [{"pipeline_project_stalled": { "$exists" : false } }, {"pipeline_project_stalled": false }] },
			  { "$or" : [{"pipeline_project_abandoned": { "$exists" : false } }, {"pipeline_project_abandoned": false }] },
			] 
		  },
		},
		{
		  name: "Stalled",
		  filter: "stalled",
		  dropdown_name: "Stalled",
		  search_value: { 
			$or: [
			  { "pipeline_project_stalled": true }
			] 
		  },
		},
		{
		  name: "Abandoned",
		  filter: "abandoned",
		  dropdown_name: "Abandoned",
		  search_value: { 
			$or: [
			  { "pipeline_project_abandoned": true }
			] 
		   },
		}
	  ],
	},
  ];
  
export const _pipelineMapFilters = [
  /*
	{
		name: "Ownership",
		show_name: true,
		search_key: "pipeline_project_components",
		filter_type: "building",
		type : "residential",
		values: [
			{
				name: "Any",
				filter: "",
				dropdown_name: "Any",
				search_value: ""
			},
			{
				name: "Condo",
				filter: "condo",
				dropdown_name: "Condo",
				search_value: {"$in" : ["condo", "condominium"]},
			},
			{
				name: "Co-op",
				filter: "co-op",
				dropdown_name: "Co-op",
				search_value: {"$in" : ["coop", "co-op", "cooperative"]},
			},
			{
				name: "Rental",
				filter: "rental",
				dropdown_name: "Rental",
				search_value: { "$nin" : [ "condominium", "cooperative", "condo", "coop", "co-op" ] },
			}
			
		]
	},
*/
  {
    name: "Total Units",
    show_name: true,
    search_key: "pipeline_dwelling_units_proposed",
    type: "residential",
    values: [
      {
        name: "Any Units",
        filter: "",
        dropdown_name: "Any",
        search_value: "",
      },
      {
        name: "1-10 Total Units",
        filter: "1-to-10",
        dropdown_name: "1 to 10 Units",
        search_value: [
          "all",
          [">=", "pipeline_dwelling_units_proposed", 1],
          ["<=", "pipeline_dwelling_units_proposed", 10],
        ],
      },
      {
        name: "11-30 Total Units",
        filter: "11-to-30",
        dropdown_name: "11 to 30 Units",
        search_value: [
          "all",
          [">=", "pipeline_dwelling_units_proposed", 11],
          ["<=", "pipeline_dwelling_units_proposed", 30],
        ],
      },
      {
        name: "31-50 Total Units",
        filter: "31-to-50",
        dropdown_name: "31 to 50 Units",
        search_value: [
          "all",
          [">=", "pipeline_dwelling_units_proposed", 31],
          ["<=", "pipeline_dwelling_units_proposed", 50],
        ],
      },
      {
        name: "51-100 Total Units",
        filter: "51-to-100",
        dropdown_name: "51 to 100 Units",
        search_value: [
          "all",
          [">=", "pipeline_dwelling_units_proposed", 51],
          ["<=", "pipeline_dwelling_units_proposed", 100],
        ],
      },
      {
        name: "101-200 Total Units",
        filter: "101-to-200",
        dropdown_name: "101 to 200 Units",
        search_value: [
          "all",
          [">=", "pipeline_dwelling_units_proposed", 101],
          ["<=", "pipeline_dwelling_units_proposed", 200],
        ],
      },
      {
        name: "201 + Total Units",
        filter: "201-or-more",
        dropdown_name: "201 or more Units",
        search_value: [">", "pipeline_dwelling_units_proposed", 200],
      },
    ],
  },
  {
    name: "Total Floors",
    show_name: true,
    search_key: "pipeline_building_stories_proposed",
    values: [
      {
        name: "Any Units",
        filter: "",
        dropdown_name: "Any",
        search_value: "",
      },
      {
        name: "1 Floor",
        filter: "1",
        dropdown_name: "1 Floor",
        search_value: ["==", "pipeline_building_stories_proposed", 1],
      },
      {
        name: "2 Floors",
        filter: "2",
        dropdown_name: "2 Floors",
        search_value: ["==", "pipeline_building_stories_proposed", 2],
      },
      {
        name: "3-5 Floors",
        filter: "3-to-5",
        dropdown_name: "3 to 5 Floors",
        search_value: [
          "all",
          [">=", "pipeline_building_stories_proposed", 3],
          ["<=", "pipeline_building_stories_proposed", 5],
        ],
      },
      {
        name: "6-10 Floors",
        filter: "6-to-10",
        dropdown_name: "6 to 10 Floors",
        search_value: [
          "all",
          [">=", "pipeline_building_stories_proposed", 6],
          ["<=", "pipeline_building_stories_proposed", 10],
        ],
      },
      {
        name: "11-20 Floors",
        filter: "11-to-20",
        dropdown_name: "11 to 20 Floors",
        search_value: [
          "all",
          [">=", "pipeline_building_stories_proposed", 11],
          ["<=", "pipeline_building_stories_proposed", 20],
        ],
      },
      {
        name: "21-40 Floors",
        filter: "21-to-40",
        dropdown_name: "21 to 40 Floors",
        search_value: [
          "all",
          [">=", "pipeline_building_stories_proposed", 21],
          ["<=", "pipeline_building_stories_proposed", 40],
        ],
      },
      {
        name: "41+ Floors",
        filter: "41-or-more",
        dropdown_name: "41+ Floors",
        search_value: [">", "pipeline_building_stories_proposed", 40],
      },
    ],
  },
  /*
	{
		name: "Resi Area",
		show_name: true,
		search_key: "pipeline_zoning_area_residential",
		type : "residential",
		values: [
			{
				name: "Any",
				filter: "",
				dropdown_name: "Any",
				search_value: ""
			},
			{
				name: "25,000 or More SF",
				filter: "25-and-more",
				dropdown_name: "25,000 or More SF",
				search_value: { "$gte" : 25000 }
			},
			{
				name: "5,000 SF or Less",
				filter: "1",
				dropdown_name: "5,000 SF or Less",
				search_value: { "$lte" : 5000 }
			},
			{
				name: "5,001 - 10,000 SF",
				filter: "5-to-10",
				dropdown_name: "5,001 - 10,000 SF",
				search_value: { "$gte" : 5001, "$lte" : 10000 }
			},
			{
				name: "10,001 - 25,000 SF",
				filter: "10-to-25",
				dropdown_name: "10,001 - 20,000 SF",
				search_value: { "$gte" : 10001, "$lte" : 20000 }
			},
			{
				name: "25,001 - 50,000 SF",
				filter: "25-to-50",
				dropdown_name: "25,001 - 50,000 SF",
				search_value: { "$gte" : 20001, "$lte" : 50000 }
			},
			{
				name: "50,001 - 100,000 SF",
				filter: "50-to-100",
				dropdown_name: "50,001 - 100,000 SF",
				search_value: { "$gte" : 50001, "$lte" : 100000 }

			},
			{
				name: "100,001 - 250,000 SF",
				filter: "100-to-250",
				dropdown_name: "100,001 - 250,000 SF",
				search_value: { "$gte" : 100001, "$lte" : 250000 }
			},
			{
				name: "250,001 - 500,000 SF",
				filter: "250-to-500",
				dropdown_name: "250,001 - 500,000 SF",
				search_value: { "$gte" : 250001, "$lte" : 500000 }
			},
			{
				name: "500,001 - 1M SF",
				filter: "500-to-1m",
				dropdown_name: "500,001 - 1M SF",
				search_value: { "$gte" : 500001, "$lte" : 1000000 }
			},
			{
				name: "More Than 1M SF",
				filter: "1m-and-more",
				dropdown_name: "More Than 1M SF",
				search_value: { "$gte" : 1000001 }
			},
		]
	},
*/
  {
    name: "Total Area",
    show_name: true,
    search_key: "pipeline_total_construction_floor_area",
    values: [
      {
        name: "25,000 or More SF",
        filter: "25-and-more",
        dropdown_name: "25,000 or More SF",
        search_value: [">=", "pipeline_total_construction_floor_area", 25000],
      },
      {
        name: "5,000 SF or Less",
        filter: "1",
        dropdown_name: "5,000 SF or Less",
        search_value: ["<=", "pipeline_total_construction_floor_area", 5000],
      },
      {
        name: "5,001 - 10,000 SF",
        filter: "5-to-10",
        dropdown_name: "5,001 - 10,000 SF",
        search_value: [
          "all",
          [">=", "pipeline_total_construction_floor_area", 5001],
          ["<=", "pipeline_total_construction_floor_area", 10000],
        ],
      },
      {
        name: "10,001 - 25,000 SF",
        filter: "10-to-25",
        dropdown_name: "10,001 - 25,000 SF",
        search_value: [
          "all",
          [">=", "pipeline_total_construction_floor_area", 10001],
          ["<=", "pipeline_total_construction_floor_area", 25000],
        ],
      },
      {
        name: "25,001 - 50,000 SF",
        filter: "25-to-50",
        dropdown_name: "25,001 - 50,000 SF",
        search_value: [
          "all",
          [">=", "pipeline_total_construction_floor_area", 25001],
          ["<=", "pipeline_total_construction_floor_area", 50000],
        ],
      },
      {
        name: "50,001 - 100,000 SF",
        filter: "50-to-100",
        dropdown_name: "50,001 - 100,000 SF",
        search_value: [
          "all",
          [">=", "pipeline_total_construction_floor_area", 50001],
          ["<=", "pipeline_total_construction_floor_area", 100000],
        ],
      },
      {
        name: "100,001 - 250,000 SF",
        filter: "100-to-250",
        dropdown_name: "100,001 - 250,000 SF",
        search_value: [
          "all",
          [">=", "pipeline_total_construction_floor_area", 100001],
          ["<=", "pipeline_total_construction_floor_area", 250000],
        ],
      },
      {
        name: "250,001 - 500,000 SF",
        filter: "250-to-500",
        dropdown_name: "250,001 - 500,000 SF",
        search_value: [
          "all",
          [">=", "pipeline_total_construction_floor_area", 250001],
          ["<=", "pipeline_total_construction_floor_area", 500000],
        ],
      },
      {
        name: "500,001 - 1M SF",
        filter: "500-to-1m",
        dropdown_name: "500,001 - 1M SF",
        search_value: [
          "all",
          [">=", "pipeline_total_construction_floor_area", 500001],
          ["<=", "pipeline_total_construction_floor_area", 1000000],
        ],
      },
      {
        name: "More Than 1M SF",
        filter: "1m-and-more",
        dropdown_name: "More Than 1M SF",
        search_value: ["<=", "pipeline_total_construction_floor_area", 1000001],
      },
    ],
  },
  /*
	{
		name: "Permit Filed",
		show_name: true,
		exclude_stage: ["pipeline"],
		search_key: "pipeline_filing_date",
		values: [
			{
				name: "Any",
				filter: "",
				dropdown_name: "Any",
				search_value: ""
			},
			{
				name: "Not Started",
				filter: "not-started",
				dropdown_name: "Not Started",
				search_value: {"$exists" : false},
			},
			{
				name: "Has Started",
				filter: "has-started",
				dropdown_name: "Has Started",
				search_value: { "$gte" : moment().add(-25, "year").toDate().toISOString(), "$lte" : moment().toDate().toISOString() },
			},
			{
				name: "Within 1 Year",
				filter: "1-year",
				dropdown_name: "Within 1 Year",
				search_value: { "$gte" : moment().add(-1, "year").toDate().toISOString(), "$lte" : moment().toDate().toISOString() },
			},
			{
				name: "1 to 2 Years",
				filter: "2-year",
				dropdown_name: "Last 1 to 2 Years",
				search_value: { "$gte" : moment().add(-2, "year").toDate().toISOString(), "$lte" : moment().toDate().toISOString() },
			},
			{
				name: "2 to 5 Years",
				filter: "2-5-year",
				dropdown_name: "Last 2 to 5 Years",
				search_value: { "$gte" : moment().add(-5, "year").toDate().toISOString(), "$lte" : moment().add(-2, "year").toDate().toISOString() },
			},
			{
				name: "5 to 10 Years",
				filter: "5-10-year",
				dropdown_name: "Last 5 to 10 Years",
				search_value: { "$gte" : moment().add(-10, "year").toDate().toISOString(), "$lte" : moment().add(-5, "year").toDate().toISOString() },
			},
			{
				name: "10 to 15 Years",
				filter: "10-15-year",
				dropdown_name: "Last 10 to 15 Years",
				search_value: { "$gte" : moment().add(-15, "year").toDate().toISOString(), "$lte" : moment().add(-10, "year").toDate().toISOString() },
			},
			{
				name: "More Than 15 Years",
				filter: "more-15-year",
				dropdown_name: "More Than 15 Years Ago",
				search_value: { "$gte" : moment().add(-20, "year").toDate().toISOString(), "$lte" : moment().add(-15, "year").toDate().toISOString() },
			}			
		]
	}
*/
];

export const _marketActivityFilters = [
  {
    name: "Price",
    show_name: true,
    search_key: ["min_price", "max_price"],
    price_filter: true,
    search_value: ["price:[{min_price} TO {max_price}]"],
  },
  {
    name: "Bedrooms",
    show_name: true,
    search_key: "bedrooms",
    values: [
      {
        name: "Any",
        filter: "",
        dropdown_name: "Any",
        search_value: "",
      },
      {
        name: "Studio",
        filter: "studio",
        dropdown_name: "Studio",
        search_value: "0",
      },
      {
        name: "1 Bedroom",
        filter: "1-bedroom",
        dropdown_name: "1 Bedroom",
        search_value: "1",
      },
      {
        name: "2 Bedroom",
        filter: "2-bedroom",
        dropdown_name: "2 Bedroom",
        search_value: "2",
      },
      {
        name: "3 Bedroom",
        filter: "3-bedroom",
        dropdown_name: "3 Bedroom",
        search_value: "3",
      },
      {
        name: "4+ Bedroom",
        filter: "4-or-more",
        dropdown_name: "4+ Bedroom",
        search_value: "[4 TO *]",
      },
    ],
  },
  {
    name: "Baths",
    show_name: true,
    search_key: "baths",
    values: [
      {
        name: "Any",
        filter: "",
        dropdown_name: "Any",
        search_value: "",
      },
      {
        name: "1 Bath",
        filter: "1-bath",
        dropdown_name: "1 Bath",
        search_value: "1",
      },
      {
        name: "2 Bath",
        filter: "2-bath",
        dropdown_name: "2 Bath",
        search_value: "2",
      },
      {
        name: "3 Bath",
        filter: "3-bath",
        dropdown_name: "3 Bath",
        search_value: "3",
      },
      {
        name: "4+ Bath",
        filter: "4-or-more",
        dropdown_name: "4+ Bath",
        search_value: "[4 TO *]",
      },
    ],
  },
  {
    name: "Interior SF",
    show_name: true,
    search_key: "sq_ft",
    values: [
      {
        name: "Any Units",
        filter: "",
        dropdown_name: "Any",
        search_value: "",
      },
      {
        name: "< 500 ",
        filter: "less-than-500",
        dropdown_name: "Less than 500 SF",
        search_value: "[10 TO 500]",
      },
      {
        name: "501 to 750 SF",
        filter: "501-to-750",
        dropdown_name: "501 to 750 SF",
        search_value: "[501 TO 750]",
      },
      {
        name: "751 to 1,000 SF",
        filter: "751-to-1000",
        dropdown_name: "751 to 1000 SF",
        search_value: "[751 TO 1000]",
      },
      {
        name: "1,001 to 1,500 SF",
        filter: "1001-to-1500",
        dropdown_name: "1,001 to 1,500 SF",
        search_value: "[1001 TO 1500]",
      },
      {
        name: "1,501 to 2,000 SF",
        filter: "1501-to-2000",
        dropdown_name: "1,501 to 2,000 SF",
        search_value: "[1501 TO 2000]",
      },
      {
        name: "2,001 to 3,000 SF",
        filter: "2001-to-3000",
        dropdown_name: "2,001 to 3,000 SF",
        search_value: "[2001 TO 3000]",
      },
      {
        name: "3,000+ SF",
        filter: "3001-or-more",
        dropdown_name: "More than 3000 SF",
        search_value: "[3001 TO *]",
      },
    ],
  },
  {
    name: "Exterior SF",
    show_name: true,
    search_key: "offering_exterior_sq_ft",
    filter_type: "property",
    values: [
      {
        name: "Any",
        filter: "",
        dropdown_name: "Any",
        search_value: "",
      },
      {
        name: "Has Exterior SF",
        filter: "has-exterior-sf",
        dropdown_name: "Has Exterior SF",
        search_value: "[1 TO *]",
      },
      {
        name: "No Exterior SF",
        filter: "no-exterior-sf",
        dropdown_name: "No Exterior SF",
        search_value: "[* TO 0]",
      },
      {
        name: "< 50 ",
        filter: "less-than-50",
        dropdown_name: "Less than 50 SF",
        search_value: "[0 TO 50]",
      },
      {
        name: "50 to 100 SF",
        filter: "50-to-100",
        dropdown_name: "50 to 100 SF",
        search_value: "[51 TO 100]",
      },
      {
        name: "101 to 200 SF",
        filter: "100-to-200",
        dropdown_name: "101 to 200 SF",
        search_value: "[101 TO 200]",
      },
      {
        name: "201 to 500 SF",
        filter: "200-to-500",
        dropdown_name: "201 to 500 SF",
        search_value: "[201 TO 500]",
      },
      {
        name: "500+ SF",
        filter: "500-more",
        dropdown_name: "More than 500 SF",
        search_value: "[501 TO *]",
      },
    ],
  },
  {
    name: "Year Built",
    show_name: true,
    search_key: "year_built",
    filter_type: "building",
    values: [
      {
        name: "Any",
        filter: "",
        dropdown_name: "Any",
        search_value: "",
      },
      {
        name: `New (After ${new_building_start})`,
        filter: "new-contruction",
        dropdown_name: `New (After ${new_building_start})`,
        search_value: `[ ${new_building_start + 1} TO *]`,
      },
      {
        name: `Recent (1991 to ${new_building_start})`,
        filter: "recent-construction",
        dropdown_name: `Recent (1991 to ${new_building_start})`,
        search_value: `[1991 TO ${new_building_start}]`,
      },
      {
        name: "Post-War (1946 to 1990)",
        filter: "post-war",
        dropdown_name: "Post-War (1946 to 1990)",
        search_value: "[1946 TO 1990]",
      },
      {
        name: "Pre-War (Before 1946)",
        filter: "pre-war",
        dropdown_name: "Pre-War (Before 1946)",
        search_value: "[1600 TO 1945]",
      },
    ],
  },
  {
    name: "Total Units",
    show_name: true,
    search_key: "residential_units",
    filter_type: "building",
    values: [
      {
        name: "Any Units",
        filter: "",
        dropdown_name: "Any",
        search_value: "",
      },
      {
        name: "1-10 Total Units",
        filter: "1-to-10",
        dropdown_name: "1 to 10 Units",
        search_value: "[1 TO 10]",
      },
      {
        name: "11-30 Total Units",
        filter: "11-to-30",
        dropdown_name: "11 to 30 Units",
        search_value: "[11 TO 30]",
      },
      {
        name: "31-50 Total Units",
        filter: "31-to-50",
        dropdown_name: "31 to 50 Units",
        search_value: "[31 TO 50]",
      },
      {
        name: "51-100 Total Units",
        filter: "51-to-100",
        dropdown_name: "51 to 100 Units",
        search_value: "[51 TO 100]",
      },
      {
        name: "101-200 Total Units",
        filter: "101-to-200",
        dropdown_name: "101 to 200 Units",
        search_value: "[101 TO 200]",
      },
      {
        name: "201 + Total Units",
        filter: "201-or-more",
        dropdown_name: "201 or more Units",
        search_value: "[201 TO *]",
      },
    ],
  },
  {
    name: "Unsold Units",
    show_name: true,
    exclude_stage: ["pipeline"],
    search_key: "inventory_unsold",
    filter_type: "building",
    values: [
      {
        name: "Any Unsold Units",
        filter: "",
        dropdown_name: "Any",
        search_value: "",
      },
      {
        name: "1-10 Unsold Units",
        filter: "1-to-10",
        dropdown_name: "1 to 10",
        search_value: "[1 TO 10]",
      },
      {
        name: "11-30 Unsold Units",
        filter: "11-to-30",
        dropdown_name: "11 to 30",
        search_value: "[11 TO 30]",
      },
      {
        name: "31-50 Unsold Units",
        filter: "31-to-50",
        dropdown_name: "31 to 50",
        search_value: "[31 TO 50]",
      },
      {
        name: "51-100 Unsold Units",
        filter: "51-to-100",
        dropdown_name: "51 to 100",
        search_value: "[51 TO 100]",
      },
      {
        name: "101-200 Unsold Units",
        filter: "101-to-200",
        dropdown_name: "101 to 200",
        search_value: "[101 TO 200]",
      },
      {
        name: "201 + Unsold Units",
        filter: "201-or-more",
        dropdown_name: "201 or more",
        search_value: "[201 TO *]",
      },
    ],
  },
  {
    name: "% Sold",
    show_name: true,
    exclude_stage: ["pipeline"],
    search_key: "inventory_pct_sold",
    filter_type: "building",
    values: [
      {
        name: "Any",
        filter: "",
        dropdown_name: "Any",
        search_value: "",
      },
      {
        name: "Has Sales",
        filter: "has-sales",
        dropdown_name: "Has Sales",
        search_value: '[1 TO *] OR offering_verified_status:"sold out"',
      },
      {
        name: "Has No Sales",
        filter: "no-sales",
        dropdown_name: "Has No Sales",
        search_value: '[* TO 0] AND -offering_verified_status:"sold out"',
      },
      {
        name: "Less Than 15%",
        filter: "0-to-15",
        dropdown_name: "Less Than 15%",
        search_value: "[0 TO 15]",
      },
      {
        name: "Less Than 35%",
        filter: "0-to-35",
        dropdown_name: "Less Than 35%",
        search_value: "[0 TO 34]",
      },
      {
        name: "Less Than 50%",
        filter: "0-to-49",
        dropdown_name: "Less Than 50%",
        search_value: "[0 TO 49]",
      },
      {
        name: "More Than 15%",
        filter: "15-to-100",
        dropdown_name: "More Than 15%",
        search_value: "[15 TO *]",
      },
      {
        name: "More Than 50%",
        filter: "50-to-100",
        dropdown_name: "More Than 50%",
        search_value: "[50 TO *]",
      },
      {
        name: "50% to 79%",
        filter: "50-to-79",
        dropdown_name: "50% to 79%",
        search_value: "[50 TO 79]",
      },
      {
        name: "80% to 99%",
        filter: "80-to-99",
        dropdown_name: "80% to 99%",
        search_value: "[80 TO 99]",
      },
      {
        name: "Sold Out",
        filter: "100 TO *",
        dropdown_name: "Sold Out",
        search_value: "[100 TO *]",
      },
    ],
  },
  {
    name: "Construction",
    show_name: true,
    search_key: "building_effective_start",
    filter_type: "building",
    values: [
      {
        name: "Any",
        filter: "",
        dropdown_name: "Any",
        search_value: "",
      },
      {
        name: "Move-in Ready",
        filter: "completed",
        dropdown_name: "Move-in Ready (Has CO/TCO)",
        search_value:
          '[NOW-25YEARS TO NOW] OR building_status:(resale) OR offering_verified_status:("sold out")',
      },
      {
        name: "Under Construction",
        filter: "not-completed",
        dropdown_name: "Under Construction (No CO/TCO)",
        search_value:
          '[* TO NOW-25YEARS] AND -building_status:(resale) AND -offering_verified_status:("sold out")',
      },
    ],
  },
  {
    name: "Offering Type",
    show_name: true,
    search_key: "offering_construction",
    filter_type: "building",
    values: [
      {
        name: "Any",
        filter: "",
        dropdown_name: "Any",
        search_value: "",
      },
      {
        name: "New Construction",
        filter: "new-construction",
        dropdown_name: "New Construction",
        search_value: "new",
      },
      {
        name: "Conversion",
        filter: "conversion",
        dropdown_name: "Conversion",
        search_value: "conversion",
      },
      {
        name: "Rehab",
        filter: "rehab",
        dropdown_name: "Rehab",
        search_value: "rehab",
      },
      {
        name: "Exclude Conversion",
        filter: "exclude-conversion",
        dropdown_name: "Exclude Conversion",
        search_value: '(new rehab "")',
      },
    ],
  },
  {
    name: "Ownership",
    show_name: true,
    search_key: "ownership_type",
    filter_type: "building",
    values: [
      {
        name: "Any",
        filter: "",
        dropdown_name: "Any",
        search_value: "",
      },
      {
        name: "Condo",
        filter: "condo",
        dropdown_name: "Condo",
        search_value: "condo AND -ownership_type:cooperative",
      },
      {
        name: "Co-op",
        filter: "co-op",
        dropdown_name: "Co-op",
        search_value: "coop",
      },
    ],
  },
  {
    name: "Sales Started",
    show_name: true,
    admin_only: true,
    exclude_stage: ["pipeline"],
    search_key: "sales_start_date",
    filter_type: "building",
    values: [
      {
        name: "Any",
        filter: "",
        dropdown_name: "Any",
        search_value: "",
      },
      {
        name: "Not Started",
        filter: "not-started",
        dropdown_name: "Not Started",
        search_value: "[1970-01-01T00:00:00Z TO 1970-01-02T00:00:00Z]",
      },
      {
        name: "Has Started",
        filter: "has-started",
        dropdown_name: "Has Started",
        search_value: "[NOW-15YEARS TO NOW]",
      },
      {
        name: "Within 1 Year",
        filter: "1-year",
        dropdown_name: "Within 1 Year",
        search_value: "[NOW-1YEARS TO NOW]",
      },
      {
        name: "1 to 2 Years",
        filter: "2-year",
        dropdown_name: "Last 1 to 2 Years",
        search_value: "[NOW-2YEARS TO NOW-1YEARS]",
      },
      {
        name: "2 to 5 Years",
        filter: "2-5-year",
        dropdown_name: "Last 2 to 5 Years",
        search_value: "[NOW-5YEARS TO NOW-2YEARS]",
      },
      {
        name: "5 to 10 Years",
        filter: "5-10-year",
        dropdown_name: "Last 5 to 10 Years",
        search_value: "[NOW-10YEARS TO NOW-5YEARS]",
      },
      {
        name: "10 to 15 Years",
        filter: "10-15-year",
        dropdown_name: "Last 10 to 15 Years",
        search_value: "[NOW-15YEARS TO NOW-10YEARS]",
      },
      {
        name: "More Than 15 Years",
        filter: "more-15-year",
        dropdown_name: "More Than 15 Years Ago",
        search_value: "[NOW-20YEARS TO NOW-15YEARS]",
      },
    ],
  },
  {
    name: "Last Listing",
    show_name: true,
    admin_only: true,
    exclude_stage: ["pipeline"],
    search_key: "last_listed_sale_date_formatted",
    filter_type: "building",
    values: [
      {
        name: "Any",
        filter: "",
        dropdown_name: "Any",
        search_value: "",
      },
      {
        name: "No Activity",
        filter: "no-activity",
        dropdown_name: "No Activity",
        search_value: "[1970-01-01T00:00:00Z TO 1970-01-02T00:00:00Z]",
      },
      {
        name: "Any Activity",
        filter: "any-activity",
        dropdown_name: "Any Activity",
        search_value: "[NOW-15YEARS TO NOW]",
      },
      {
        name: "Within 1 Year",
        filter: "1-year",
        dropdown_name: "Within 1 Year",
        search_value: "[NOW-1YEARS TO NOW]",
      },
      {
        name: "1 to 2 Years",
        filter: "2-year",
        dropdown_name: "Last 1 to 2 Years",
        search_value: "[NOW-2YEARS TO NOW-1YEARS]",
      },
      {
        name: "2 to 5 Years",
        filter: "2-5-year",
        dropdown_name: "Last 2 to 5 Years",
        search_value: "[NOW-5YEARS TO NOW-2YEARS]",
      },
      {
        name: "More Than 5 Years",
        filter: "more-5-year",
        dropdown_name: "More Than 5 Years Ago",
        search_value: "[NOW-15YEARS TO NOW-5YEARS]",
      },
    ],
  },
  {
    name: "Last Contract",
    show_name: true,
    admin_only: true,
    exclude_stage: ["pipeline"],
    search_key: "last_contract_date_formatted",
    filter_type: "building",
    values: [
      {
        name: "Any",
        filter: "",
        dropdown_name: "Any",
        search_value: "",
      },
      {
        name: "No Activity",
        filter: "no-activity",
        dropdown_name: "No Activity",
        search_value: "[1970-01-01T00:00:00Z TO 1970-01-02T00:00:00Z]",
      },
      {
        name: "Any Activity",
        filter: "any-activity",
        dropdown_name: "Any Activity",
        search_value: "[NOW-15YEARS TO NOW]",
      },
      {
        name: "Within 1 Year",
        filter: "1-year",
        dropdown_name: "Within 1 Year",
        search_value: "[NOW-1YEARS TO NOW]",
      },
      {
        name: "1 to 2 Years",
        filter: "2-year",
        dropdown_name: "Last 1 to 2 Years",
        search_value: "[NOW-2YEARS TO NOW-1YEARS]",
      },
      {
        name: "2 to 5 Years",
        filter: "2-5-year",
        dropdown_name: "Last 2 to 5 Years",
        search_value: "[NOW-5YEARS TO NOW-2YEARS]",
      },
      {
        name: "More Than 5 Years",
        filter: "more-5-year",
        dropdown_name: "More Than 5 Years Ago",
        search_value: "[NOW-15YEARS TO NOW-5YEARS]",
      },
    ],
  },
  {
    name: "Last Sale",
    show_name: true,
    admin_only: true,
    exclude_stage: ["pipeline"],
    search_key: "last_sold_date_formatted",
    filter_type: "building",
    values: [
      {
        name: "Any",
        filter: "",
        dropdown_name: "Any",
        search_value: "",
      },
      {
        name: "No Activity",
        filter: "no-activity",
        dropdown_name: "No Activity",
        search_value:
          '[1970-01-01T00:00:00Z TO 1970-01-02T00:00:00Z] AND -offering_verified_status:"sold out"',
      },
      {
        name: "Any Activity",
        filter: "any-activity",
        dropdown_name: "Any Activity",
        search_value:
          '[NOW-15YEARS TO NOW] OR offering_verified_status:"sold out"',
      },
      {
        name: "Within 1 Year",
        filter: "1-year",
        dropdown_name: "Within 1 Year",
        search_value: "[NOW-1YEARS TO NOW]",
      },
      {
        name: "1 to 2 Years",
        filter: "2-year",
        dropdown_name: "Last 1 to 2 Years",
        search_value: "[NOW-2YEARS TO NOW-1YEARS]",
      },
      {
        name: "2 to 5 Years",
        filter: "2-5-year",
        dropdown_name: "Last 2 to 5 Years",
        search_value: "[NOW-5YEARS TO NOW-2YEARS]",
      },
      {
        name: "More Than 5 Years",
        filter: "more-5-year",
        dropdown_name: "More Than 5 Years Ago",
        search_value: "[NOW-15YEARS TO NOW-5YEARS]",
      },
    ],
  },
  {
    name: "Condo Dec",
    show_name: true,
    exclude_stage: ["pipeline"],
    search_key: "cdec_date",
    filter_type: "building",
    values: [
      {
        name: "Any",
        filter: "",
        dropdown_name: "Any",
        search_value: "",
      },
      {
        name: "No Condo Dec",
        filter: "no-cdec",
        dropdown_name: "No Condo Dec",
        search_value: "[1970-01-01T00:00:00Z TO 1970-01-02T00:00:00Z]",
      },
      {
        name: "Has Condo Dec",
        filter: "has-cdec",
        dropdown_name: "Has Condo Dec",
        search_value: "[NOW-15YEARS TO NOW]",
      },
    ],
  },
  {
    name: "Offering Status",
    show_name: true,
    admin_only: true,
    search_key: "offering_submitted_date",
    filter_type: "building",
    values: [
      {
        name: "Any",
        filter: "",
        dropdown_name: "Any",
        search_value: "",
      },
      {
        name: "All Submitted",
        filter: "submitted",
        dropdown_name: "All Submitted",
        search_value: "[NOW-25YEARS TO NOW]",
      },
      {
        name: "All Accepted",
        filter: "accepted",
        dropdown_name: "All Accepted",
        search_value:
          "[NOW-25YEARS TO NOW] AND offering_accepted_date:[NOW-25YEARS TO NOW]",
      },
      {
        name: "All Effective",
        filter: "effective",
        dropdown_name: "All Effective",
        search_value:
          "[NOW-25YEARS TO NOW] AND offering_effective_date:[NOW-25YEARS TO NOW]",
      },
      {
        name: "Only Submitted",
        filter: "submitted-only",
        dropdown_name: "Only Submitted",
        search_value:
          "[NOW-25YEARS TO NOW] AND offering_accepted_date:[1970-01-01T00:00:00Z TO 1970-01-02T00:00:00Z]",
      },
      {
        name: "Only Accepted",
        filter: "accepted-only",
        dropdown_name: "Only Accepted",
        search_value:
          "[NOW-25YEARS TO NOW] AND offering_accepted_date:[NOW-25YEARS TO NOW] AND offering_effective_date:[1970-01-01T00:00:00Z TO 1970-01-02T00:00:00Z]",
      },
      {
        name: "Only Effectiv Only",
        filter: "effective-only",
        dropdown_name: "Only Effective",
        search_value:
          "[NOW-25YEARS TO NOW] AND offering_effective_date:[NOW-25YEARS TO NOW]",
      },
    ],
  },
];

export const _pipeLineFilter = [
  /*	{
		name: "Stage",
		show_name: true,
		search_key: "event_tags",
		values: [
			{
				name: "Any",
				filter: "",
				dropdown_name: "Any",
				search_value: ""
			},
			{
				name: "Permit Filed",
				filter: "permit-filed",
				dropdown_name: "Permit Filed",
				search_value: "permit-filing",
			},
			{
				name: "Offering Submitted",
				filter: "offering-submitted",
				dropdown_name: "Offering Submitted",
				search_value: "submitted",
			},
			{
				name: "Offering Accepted",
				filter: "offering-accepted",
				dropdown_name: "Offering Accepted",
				search_value: "accepted",
			},
			{
				name: "Offering Effective",
				filter: "offering-effective",
				dropdown_name: "Offering Effective",
				search_value: "effective",
			},
			
		]
	},	*/
  {
    name: "Type",
    show_name: true,
    multi_filter: true,
    search_key: "topic",
    values: [
      {
        name: "Any",
        filter: "",
        dropdown_name: "Any",
        search_value: "",
      },
      {
        name: "Construction",
        filter: "new-building",
        dropdown_name: "New Building",
        search_value: "permits AND event_tags:(nb a1)",
      },
      {
        name: "Demolition",
        filter: "demolition",
        dropdown_name: "Demolition",
        search_value: "permits AND event_tags:dm",
      },
     {
       name: "Offering Plan",
       filter: "offering-submitted",
       dropdown_name: "Offering Plan",
       search_value: "offeringplans",
     },
      
      {
        name: "Certificate of Occupancy",
        filter: "coo",
        dropdown_name: "Certificate of Occupancy",
        search_value: "coo",
      }
    ],
  },
  {
    name: "Subtype",
    show_name: true,
    multi_filter: true,
    search_key: "event_tags",
    values: [
      {
        name: "Any",
        filter: "",
        dropdown_name: "Any",
        search_value: "",
      },
      {
        name: "New Building Permit",
        filter: "new-building",
        dropdown_name: "New Building",
        search_value: "nb AND topic:permits",
      },
      {
        name: "Major Alteration Permit",
        filter: "major-alteration",
        dropdown_name: "Major Alteration",
        search_value: "a1 AND topic:permits",
      },
      {
        name: "Demolition Permit",
        filter: "demolition",
        dropdown_name: "Demolition",
        search_value: "dm AND topic:permits",
      },
      {
        name: "Offering Submitted",
        filter: "offering-submitted",
        dropdown_name: "Demolition",
        search_value: "submitted AND topic:offeringplans",
      },
      {
        name: "Offering Accepted",
        filter: "offering-accepted",
        dropdown_name: "Offering Accepted",
        search_value: "accepted AND topic:offeringplans",
      },
      {
        name: "Offering Effective",
        filter: "offering-effective",
        dropdown_name: "Offering Effective",
        search_value: "effective AND topic:offeringplans",
      },
     {
       name: "Final CO",
       filter: "coo-final",
       dropdown_name: "Final CO",
       search_value: "coo-final",
     },
      {
        name: "Temporary CO",
        filter: "coo-temporary",
        dropdown_name: "Temporary CO",
        search_value: "coo-temporary",
      }
    ],
  },
  {
    name: "Total Units",
    show_name: true,
    price_filter: true,
    value_contains_key: true,
    filter_key: "units",
    search_key: ["min_units", "max_units"],
    labels: ["Min Units", "Max Units"],
    min_max_values: [25, 200],
    min_max_increment: 25,
    custom_min_max_values: {
      min: [1, 11, 31, 51, 101, 201],
      max: [10, 30, 50, 100, 200, 300],
    },
    format_type: "number",
    search_value: [
      "units:[{min_units} TO {max_units}]",
    ],
    value_prefix: "",
    title_suffix: "Units",
    // search_key: "units",
    values: [
      {
        name: "Any Units",
        filter: "",
        dropdown_name: "Any",
        search_value: "",
      },
      {
        name: "3-10 Units",
        filter: "3-to-10",
        dropdown_name: "3 to 10 Units",
        search_value: "[3 TO 10]",
      },
      {
        name: "11-30 Units",
        filter: "11-to-30",
        dropdown_name: "11 to 30 Units",
        search_value: "[11 TO 30]",
      },
      {
        name: "31-50 Units",
        filter: "31-to-50",
        dropdown_name: "31 to 50 Units",
        search_value: "[31 TO 50]",
      },
      {
        name: "51-100 Units",
        filter: "51-to-100",
        dropdown_name: "51 to 100 Units",
        search_value: "[51 TO 100]",
      },
      {
        name: "101-200 Units",
        filter: "101-to-200",
        dropdown_name: "101 to 200 Units",
        search_value: "[101 TO 200]",
      },
      {
        name: "201 + Units",
        filter: "201-or-more",
        dropdown_name: "201 or more Units",
        search_value: "[201 TO *]",
      },
    ],
  },
  {
    name: "Total Floors",
    show_name: true,
    price_filter: true,
    value_contains_key: true,
    filter_key: "floor",
    search_key: ["min_floors", "max_floors"],
    labels: ["Min Floors", "Max Floors"],
    min_max_values: [1, 41],
    min_max_increment: 10,
    custom_min_max_values: {
      min: [1, 6, 11, 21, 41],
      max: [5, 10, 20, 40],
    },
    format_type: "number",
    search_value: [
      "floor:[{min_floors} TO {max_floors}]",
    ],
    value_prefix: "",
    title_suffix: "Floors",
    values: [
      {
        name: "Any Units",
        filter: "",
        dropdown_name: "Any",
        search_value: "",
      },
      {
        name: "1-5 Floors",
        filter: "1-to-10",
        dropdown_name: "1 to 5 Floors",
        search_value: "[1 TO 5]",
      },
      {
        name: "6-10 Floors",
        filter: "6-to-10",
        dropdown_name: "6 to 10 Floors",
        search_value: "[6 TO 10]",
      },
      {
        name: "11-20 Floors",
        filter: "11-to-20",
        dropdown_name: "11 to 20 Floors",
        search_value: "[11 TO 20]",
      },
      {
        name: "21-30 Floors",
        filter: "21-to-30",
        dropdown_name: "21 to 30 Floors",
        search_value: "[21 TO 30]",
      },
      {
        name: "31-40 Floors",
        filter: "31-to-40",
        dropdown_name: "31 to 40 Floors",
        search_value: "[31 TO 40]",
      },
      {
        name: "40+ Floors",
        filter: "40-or-more",
        dropdown_name: "41 or More Floors",
        search_value: "[41 TO *]",
      },
    ],
  },
  {
    name: "Total Area",
    show_name: true,
    // search_key: "sq_ft",
    labels: ["Min Area", "Max Area"],
    price_filter: true,
    value_contains_key: true,
    filter_key: "sq_ft",
    search_key: ["min_total_ft", "max_total_ft"],
    min_max_values: [5000, 100000],
    min_max_increment: 500,
    custom_min_max_values: {
      min: [0, 5001, 10001, 25001, 50001, 100001, 250001, 500001, 1000001],
      max: [5000, 10000, 25000, 50000, 100000, 250000, 500000, 500001],
    },
    format_type: "number",
    search_value: [
      "sq_ft:[{min_total_ft} TO {max_total_ft}]",
    ],
    value_prefix: "",
    title_suffix: "SF",
    values: [
      {
        name: "Any",
        filter: "",
        dropdown_name: "Any",
        search_value: "",
      },
      {
        name: "25,000 or More SF",
        filter: "25-and-more",
        dropdown_name: "25,000 or More SF",
        search_value: "[25000 TO *]",
      },
      {
        name: "5,000 SF or Less",
        filter: "1",
        dropdown_name: "5,000 SF or Less",
        search_value: "[* TO 5000]",
      },
      {
        name: "5,001 - 10,000 SF",
        filter: "5-to-10",
        dropdown_name: "5,001 - 10,000 SF",
        search_value: "[5001 TO 10000]",
      },
      {
        name: "10,001 - 25,000 SF",
        filter: "10-to-25",
        dropdown_name: "10,001 - 25,000 SF",
        search_value: "[10001 TO 25000]",
      },
      {
        name: "25,001 - 50,000 SF",
        filter: "25-to-50",
        dropdown_name: "25,001 - 50,000 SF",
        search_value: "[25001 TO 50000]",
      },
      {
        name: "50,001 - 100,000 SF",
        filter: "50-to-100",
        dropdown_name: "50,001 - 100,000 SF",
        search_value: "[50001 TO 100000]",
      },
      {
        name: "100,001 - 250,000 SF",
        filter: "100-to-250",
        dropdown_name: "100,001 - 250,000 SF",
       search_value: "[100001 TO 250000]",
      },
      {
        name: "250,001 - 500,000 SF",
        filter: "250-to-500",
        dropdown_name: "250,001 - 500,000 SF",
        search_value: "[250001 TO 500000]",
      },
      {
        name: "500,001 - 1M SF",
        filter: "500-to-1m",
        dropdown_name: "500,001 - 1M SF",
        search_value: "[500001 TO 1000000]",
      },
      {
        name: "More Than 1M SF",
        filter: "1m-and-more",
        dropdown_name: "More Than 1M SF",
        search_value: "[1000000 TO *]",
      },
    ],
  },
  {
    name: "Activity Date",
    show_name: "true",
    search_key: ["start_date", "end_date"],
    date_filter: true,
    search_value: ["time:[{start_date} TO {end_date}]"],
  }
  
 /* {
    name: "Offering Type",
    show_name: true,
    search_key: "event_tags",
    values: [
      {
        name: "Any",
        filter: "",
        dropdown_name: "Any",
        search_value: "",
      },
      {
        name: "New Condo",
        filter: "new-condo",
        dropdown_name: "New Condo",
        search_value: "new-condo",
      },
      {
        name: "Condo Conversion",
        filter: "condo-conversion",
        dropdown_name: "Condo Conversion",
        search_value: "condo-conversion",
      },
      {
        name: "New Co-op",
        filter: "new-coop",
        dropdown_name: "New Co-op",
        search_value: "new-coop",
      },
      {
        name: "Co-op Conversion ",
        filter: "coop-conversion",
        dropdown_name: "Co-op Conversion",
        search_value: "coop-conversion",
      },
    ],
  },
  {
    name: "Offering Sellout",
    show_name: true,
    search_key: "price",
    values: [
      {
        name: "Any",
        filter: "",
        dropdown_name: "Any",
        search_value: "",
      },
      {
        name: "Under $10M",
        filter: "under-10m",
        dropdown_name: "Under $10M",
        search_value: "[* TO 10000000]",
      },
      {
        name: "$10M to $50M",
        filter: "10-to-50",
        dropdown_name: "$10M to $50M",
        search_value: "[10000000 TO 50000000]",
      },
      {
        name: "$50M to $100M",
        filter: "50-to-100",
        dropdown_name: "$50M to $100M",
        search_value: "[50000000 TO 100000000]",
      },
      {
        name: "$100M to $200M",
        filter: "100-to-200",
        dropdown_name: "$100M to $200M",
        search_value: "[100000000 TO 200000000]",
      },
      {
        name: "More Than $200M",
        filter: "more-than-200",
        dropdown_name: "More Than $200M",
        search_value: "[200000000 TO *]",
      },
    ],
  },*/
];

export const _buildingAdminFiltersRental = [
  {
    name: "Borough",
    show_name: true,
    default_name: "All Boroughs",
    search_key: "borough",
    values: [
      {
        name: "All Boroughs",
        filter: "",
        dropdown_name: "All Boroughs",
        search_value: "",
      },
      {
        name: "Manhattan",
        filter: "manhattan",
        dropdown_name: "Manhattan",
        search_value: "manhattan",
      },
      {
        name: "Brooklyn",
        filter: "brooklyn",
        dropdown_name: "Brooklyn",
        search_value: "brooklyn",
      },
      {
        name: "Queens",
        filter: "queens",
        dropdown_name: "Queens",
        search_value: "queens",
      },
      {
        name: "Bronx",
        filter: "bronx",
        dropdown_name: "Bronx",
        search_value: "bronx",
      },
      {
        name: "Staten Island",
        filter: "staten-island",
        dropdown_name: "Staten Island",
        search_value: "staten-island",
      },
    ],
  },
  {
    name: "Type",
    show_name: true,
    search_key: "ownership_type",
    values: [
      {
        name: "Any",
        filter: "",
        dropdown_name: "Any",
        search_value: "",
      },
      {
        name: "Hybrid - Condo",
        filter: "hybrid",
        dropdown_name: "Hybrid - Condo",
        search_value:
          "* AND ((ownership_type:*condo* AND ownership_occupancy_sub_types:*rental*) OR (ownership_occupancy_sub_types:*condo* AND ownership_type:*rental*))",
      },
      {
        name: "OP Filed",
        filter: "op-filed",
        dropdown_name: "Offering Plan Filed",
        search_value: "* AND (offering_submitted_date:[NOW-15YEARS TO NOW])",
      },
    ],
  },
  {
    name: "Total Floors",
    show_name: true,
    search_key: "total_floors",
    values: [
      {
        name: "Any Units",
        filter: "",
        dropdown_name: "Any",
        search_value: "",
      },
      {
        name: "1-5 Floors",
        filter: "1-to-10",
        dropdown_name: "1 to 5 Floors",
        search_value: "[1 TO 5]",
      },
      {
        name: "6-10 Floors",
        filter: "6-to-10",
        dropdown_name: "6 to 10 Floors",
        search_value: "[6 TO 10]",
      },
      {
        name: "11-20 Floors",
        filter: "11-to-20",
        dropdown_name: "11 to 20 Floors",
        search_value: "[11 TO 20]",
      },
      {
        name: "21-30 Floors",
        filter: "21-to-30",
        dropdown_name: "21 to 30 Floors",
        search_value: "[21 TO 30]",
      },
      {
        name: "31-40 Floors",
        filter: "31-to-40",
        dropdown_name: "31 to 40 Floors",
        search_value: "[31 TO 40]",
      },
      {
        name: "40+ Floors",
        filter: "40-or-more",
        dropdown_name: "41 or More Floors",
        search_value: "[41 TO *]",
      },
    ],
  },
  /*
	{
		name: "Construction",
		show_name: true,
		search_key: "building_effective_start",
		values: [
			{
				name: "Any",
				filter: "",
				dropdown_name: "Any",
				search_value: ""
			},
			{
				name: "Move-in Ready",
				filter: "completed",
				dropdown_name: "Move-in Ready",
				search_value: "[NOW-15YEARS TO NOW]",
			},
			{
				name: "Under Construction",
				filter: "not-completed",
				dropdown_name: "Under Construction",
				search_value: "[* TO NOW-15YEARS]",
			}
			
		]
	},
*/
  {
    name: "Total Units",
    show_name: true,
    search_key: "residential_units",
    values: [
      {
        name: "Any Units",
        filter: "",
        dropdown_name: "Any",
        search_value: "",
      },
      {
        name: "1-10 Total Units",
        filter: "1-to-10",
        dropdown_name: "1 to 10 Units",
        search_value: "[1 TO 10]",
      },
      {
        name: "11-30 Total Units",
        filter: "11-to-30",
        dropdown_name: "11 to 30 Units",
        search_value: "[11 TO 30]",
      },
      {
        name: "31-50 Total Units",
        filter: "31-to-50",
        dropdown_name: "31 to 50 Units",
        search_value: "[31 TO 50]",
      },
      {
        name: "51-100 Total Units",
        filter: "51-to-100",
        dropdown_name: "51 to 100 Units",
        search_value: "[51 TO 100]",
      },
      {
        name: "101-200 Total Units",
        filter: "101-to-200",
        dropdown_name: "101 to 200 Units",
        search_value: "[101 TO 200]",
      },
      {
        name: "201 + Total Units",
        filter: "201-or-more",
        dropdown_name: "201 or more Units",
        search_value: "[201 TO *]",
      },
    ],
  },
];

export const _buildingStageFilter = [
  {
    search_key: "building_stage",
    type: "array",
    values: [
      {
        filter: "pipeline",
      },
      {
        filter: "sponsor",
      },
      {
        filter: "resale",
      },
      {
        filter: "all",
      },
    ],
  },
];

export const _unitStageFilter = [
  {
    search_key: "unit_stage",
    type: "array",
    values: [
      {
        filter: "sponsor",
      },
      {
        filter: "resale",
      },
    ],
  },
];

export const _unitSalesFilter = [
  {
    search_key: "ownership_type",
    type: "array",
    values: [
      {
        filter: "sales",
      },
    ],
  },
];

export const _unitMapListFilter = [
  {
    search_key: "viewType",
    type: "array",
    values: [
      {
        filter: "map",
      },
      {
        filter: "list",
      },
    ],
  },
]
export const _salesFilters = [
  {
    name: "Property Type",
    show_name: true,
    search_key: "ownership_type",
    multi_filter: true,
    values: [
      {
        name: "Any",
        filter: "",
        dropdown_name: "Any",
        search_value: "",
      },
      {
        name: "Vacant Land",
        filter: "vacant_land",
        dropdown_name: "Vacant Land",
        search_value: "(vacant?land)",
      },
      {
        name: "Condo / Coop Buildings",
        filter: "condo_crop_building",
        dropdown_name: "Condo / Coop Buildings",
        search_value:
          "condo co?op coop",
      },
      {
        name: "Rental Buildings",
        filter: "rental_buildings",
        dropdown_name: "Rental Buildings",
        search_value:
          "(rental apartment)",
      },
      {
        name: "Houses",
        filter: "houses",
        dropdown_name: "Houses",
        search_value:
          "townhouse single?family multi?family two?family three?family four?family five?to?six?family",
      },
      {
        name: "Commercial",
        filter: "commercial",
        dropdown_name: "Commercial",
        search_value:
          "commercial office retail public?facilities industrial vacant?land parking garage hotel",
      },
      {
        name: "Public Facilities",
        filter: "public_facilities",
        dropdown_name: "Public Facilities",
        search_value: "public?facilities religious",
      },
    ],
  },
  
  /*	{
		name: "Sold Date",
		show_name: true,
		search_key: "close_date_formatted",
		values: [
			{
				name: "Any",
				filter: "",
				dropdown_name: "Any",
				search_value: ""
			},
			{
				name: "Last 3 Months",
				filter: "3-month",
				dropdown_name: "Last 3 Months",
				search_value: "[NOW-3MONTHS TO NOW]",
			},
			{
				name: "Last 6 Months",
				filter: "6-month",
				dropdown_name: "Last 6 Months",
				search_value: "[NOW-6MONTHS TO NOW]",
			},
			{
				name: "Last 1 Year",
				filter: "1-year",
				dropdown_name: "Last 1 Year",
				search_value: "[NOW-1YEAR TO NOW]",
			},
			{
				name: "Last 2 Years",
				filter: "2-year",
				dropdown_name: "Last 2 Year",
				search_value: "[NOW-2YEAR TO NOW]",
			},
			{
				name: "Last 5 Years",
				filter: "5-year",
				dropdown_name: "Last 5 Year",
				search_value: "[NOW-5YEAR TO NOW]",
			},
			{
				name: "1 - 2 Years",
				filter: "1-2-year",
				dropdown_name: "1 - 2 Years",
				search_value: "[NOW-2YEAR TO NOW-1YEAR]",
			},
			{
				name: "2 - 5 Years",
				filter: "2-5-year",
				dropdown_name: "2 - 5 Years",
				search_value: "[NOW-5YEAR TO NOW-2YEAR]",
			},
			{
				name: "5 - 10 Years",
				filter: "5-10-year",
				dropdown_name: "5 - 10 Years",
				search_value: "[NOW-10YEAR TO NOW-5YEAR]",
			},
			{
				name: "More Than 10 Years",
				filter: "more-10-year",
				dropdown_name: "More Than 10 Years",
				search_value: "[* TO NOW-10YEAR]",
			},
		]
	},*/
  {
    name: "Sold Date",
    show_name: true,
    search_key: ["min_date", "max_date"],
    date_filter: true,
    search_value: ["close_date_formatted:[{min_date} TO {max_date}]"],
  },
  {
    name: "Price",
    show_name: true,
    value_contains_key: true,
    filter_key: "price",
    format_type: "number",
    search_key: ["min_price", "max_price"],
    price_filter: true,
    search_value: ["price:[{min_price} TO {max_price}]"],
  },
  // {
  //   name: "Bedrooms",
  //   show_name: true,
  //   search_key: "bedrooms",
  //   values: [
  //     {
  //       name: "Any",
  //       filter: "",
  //       dropdown_name: "Any",
  //       search_value: "",
  //     },
  //     {
  //       name: "Studio",
  //       filter: "studio",
  //       dropdown_name: "Studio",
  //       search_value: "0",
  //     },
  //     {
  //       name: "1 Bedroom",
  //       filter: "1-bedroom",
  //       dropdown_name: "1 Bedroom",
  //       search_value: "1",
  //     },
  //     {
  //       name: "2 Bedroom",
  //       filter: "2-bedroom",
  //       dropdown_name: "2 Bedroom",
  //       search_value: "2",
  //     },
  //     {
  //       name: "3 Bedroom",
  //       filter: "3-bedroom",
  //       dropdown_name: "3 Bedroom",
  //       search_value: "3",
  //     },
  //     {
  //       name: "4+ Bedroom",
  //       filter: "4-or-more",
  //       dropdown_name: "4+ Bedroom",
  //       search_value: "[4 TO *]",
  //     },
  //   ],
  // },
  // {
  //   name: "Baths",
  //   show_name: true,
  //   search_key: "baths",
  //   values: [
  //     {
  //       name: "Any",
  //       filter: "",
  //       dropdown_name: "Any",
  //       search_value: "",
  //     },
  //     {
  //       name: "1 Bath",
  //       filter: "1-bath",
  //       dropdown_name: "1 Bath",
  //       search_value: "1",
  //     },
  //     {
  //       name: "2 Bath",
  //       filter: "2-bath",
  //       dropdown_name: "2 Bath",
  //       search_value: "2",
  //     },
  //     {
  //       name: "3 Bath",
  //       filter: "3-bath",
  //       dropdown_name: "3 Bath",
  //       search_value: "3",
  //     },
  //     {
  //       name: "4+ Bath",
  //       filter: "4-or-more",
  //       dropdown_name: "4+ Bath",
  //       search_value: "[4 TO *]",
  //     },
  //   ],
  // },
  {
    name: "Sq Ft",
    show_name: true,
    labels: ["Min SqFt", "Max SqFt"],
    price_filter: true,
    value_contains_key: true,
    filter_key: "sq_ft",
    search_key: ["min_sq_ft", "max_sq_ft"],
    min_max_values: [500, 3000],
    min_max_increment: 250,
    custom_min_max_values: {
      min: [0, 5001, 10001, 25001, 50001, 100001, 250001, 500001, 1000001],
      max: [5000, 10000, 25000, 50000, 100000, 250000, 500000, 500001],
    },
    format_type: "number",
    search_value: [
      "sq_ft:[{min_sq_ft} TO {max_sq_ft}]",
    ],
    value_prefix: "",
    title_suffix: "SF",
    // search_key: "offering_sq_ft",
    values: [
      {
        name: "Any Units",
        filter: "",
        dropdown_name: "Any",
        search_value: "",
      },
      {
        name: "< 500 ",
        filter: "less-than-500",
        dropdown_name: "Less than 500 SF",
        search_value: "[10 TO 500] OR sq_ft:[10 TO 500] ",
      },
      {
        name: "501 to 750 SF",
        filter: "501-to-750",
        dropdown_name: "501 to 750 SF",
        search_value: "[501 TO 750] OR sq_ft:[501 TO 750] ",
      },
      {
        name: "751 to 1,000 SF",
        filter: "751-to-1000",
        dropdown_name: "751 to 1000 SF",
        search_value: "[751 TO 1000] OR sq_ft:[751 TO 1000]",
      },
      {
        name: "1,001 to 1,500 SF",
        filter: "1001-to-1500",
        dropdown_name: "1,001 to 1,500 SF",
        search_value: "[1001 TO 1500] OR sq_ft:[1001 TO 1500]",
      },
      {
        name: "1,501 to 2,000 SF",
        filter: "1501-to-2000",
        dropdown_name: "1,501 to 2,000 SF",
        search_value: "[1501 TO 2000] OR sq_ft:[1501 TO 2000]",
      },
      {
        name: "2,001 to 3,000 SF",
        filter: "2001-to-3000",
        dropdown_name: "2,001 to 3,000 SF",
        search_value: "[2001 TO 3000] OR sq_ft:[2001 TO 3000]",
      },
      {
        name: "3,000+ SF",
        filter: "3001-or-more",
        dropdown_name: "More than 3000 SF",
        search_value: "[3001 TO *] OR sq_ft:[3001 TO *]",
      },
    ],
  },
  {
    name: "Sold PPSF",
    show_name: true,
    // search_key: "price_per_sqft",
    show_name: true,
    labels: ["Min PPSF", "Max PPSF"],
    price_filter: true,
    value_contains_key: true,
    filter_key: "price_per_sqft",
    search_key: ["min_ppsf", "max_ppsf"],
    min_max_values: [500, 3000],
    min_max_increment: 250,
    custom_min_max_values: {
      min: [0, 101, 251, 501, 751, 1001, 1501, 2001, 2501, 5001],
      max: [100, 250, 500, 750, 1000, 1500, 2000, 2500, 5000],
    },
    format_type: "number",
    search_value: [
      "price_per_sqft:[{min_ppsf} TO {max_ppsf}]",
    ],
    value_prefix: "$",
    title_suffix: ""
  },
  {
    name: "Transfer Type",
    show_name: true,
    multi_filter: true,
    search_key: "parcels_count",
    values: [
      {
        name: "Any",
        filter: "",
        dropdown_name: "Any",
        search_value: "",
      },
      {
        name: "Market Transfer",
        filter: "market-transfer",
        dropdown_name: "Market Transfer",
        search_value: "* AND (price:[5001 TO *] OR price:[* TO -1])",
      },

      {
        name: "Non-Market Transfer",
        filter: "non-market",
        dropdown_name: "Non-Market Transfer",
        search_value: "* AND price:[* TO 5000]",
      },
      {
        name: "Bulk Transfer (Any)",
        filter: "bulk-transfer",
        dropdown_name: "Bulk Transfer (Any)",
        search_value:
          "[2 TO *] AND parcels_count:[* TO 0]) OR (parcels_count:[2 TO *]",
      },
      {
        name: "Bulk (2 to 5 Parcels)",
        filter: "bulk-transfer-2-to-5",
        dropdown_name: "Bulk  (2 to 5 Parcels)",
        search_value:
          "[2 TO 5] AND parcels_count:[* TO 0]) OR (parcels_count:[2 TO 5]",
      },
      {
        name: "Bulk (6 to 10 Parcels)",
        filter: "bulk-transfer-6-to-5",
        dropdown_name: "Bulk  (6 to 10 Parcels)",
        search_value:
          "[6 TO 10] AND parcels_count:[* TO 0]) OR (parcels_count:[6 TO 10]",
      },
      {
        name: "Bulk (11 to 20 Parcels)",
        filter: "bulk-transfer-11-to-20",
        dropdown_name: "Bulk  (11 to 20 Parcels)",
        search_value:
          "[11 TO 20] AND parcels_count:[* TO 0]) OR (parcels_count:[11 TO 20]",
      },
      {
        name: "Bulk (More Than 20 Parcels)",
        filter: "bulk-transfer-more-20",
        dropdown_name: "Bulk (More Than 20 Parcels)",
        search_value:
          "[21 TO *] AND parcels_count:[* TO 0]) OR (parcels_count:[21 TO *]",
      },
    ],
  },
 
  // {
  //   name: "Ownership",
  //   show_name: true,
  //   search_key: "ownership_type",
  //   values: [
  //     {
  //       name: "Any",
  //       filter: "",
  //       dropdown_name: "Any",
  //       search_value: "",
  //     },
  //     {
  //       name: "Condo",
  //       filter: "condo",
  //       dropdown_name: "Condo",
  //       search_value: "condo AND -ownership_type:cooperative",
  //     },
  //     {
  //       name: "Co-op",
  //       filter: "co-op",
  //       dropdown_name: "Co-op",
  //       search_value: "coop",
  //     },
  //   ],
  // },
  // {
  //   name: "Discount",
  //   show_name: true,
  //   search_key: "discount",
  //   values: [
  //     {
  //       name: "Any",
  //       filter: "",
  //       dropdown_name: "Any",
  //       search_value: "",
  //     },
  //     {
  //       name: "Has Discount",
  //       filter: "has-discount",
  //       dropdown_name: "Has Discount",
  //       search_value: "[-90 TO -.01]",
  //     },
  //     {
  //       name: "1% to 3%",
  //       filter: "1-to-3",
  //       dropdown_name: "1% to 3%",
  //       search_value: "[-3 TO -1]",
  //     },
  //     {
  //       name: "3% to 5%",
  //       filter: "3-to-5",
  //       dropdown_name: "3% to 5%",
  //       search_value: "[-5 TO -3]",
  //     },
  //     {
  //       name: "5% to 10%",
  //       filter: "5-to-10",
  //       dropdown_name: "5% to 10%",
  //       search_value: "[-10 TO -5]",
  //     },
  //     {
  //       name: "10% to 15%",
  //       filter: "10-to-15",
  //       dropdown_name: "10% to 15%",
  //       search_value: "[-15 TO -10]",
  //     },
  //     {
  //       name: "More Than 15%",
  //       filter: "more-15",
  //       dropdown_name: "More Than 15%",
  //       search_value: "[-90 TO -15]",
  //     },
  //     {
  //       name: "Sold for More Than Asking",
  //       filter: "more-than",
  //       dropdown_name: "Sold for More Than Asking",
  //       search_value: "[.01 TO 90]",
  //     },
  //   ],
  // },
  {
    name: "% Financed",
    show_name: true,
    // search_key: "percent_financed",
    labels: ["Min %", "Max %"],
    price_filter: true,
    value_contains_key: true,
    filter_key: "percent_financed",
    search_key: ["min_financed", "max_financed"],
    min_max_values: [1, 100],
    min_max_increment: 10,
    custom_min_max_values: {
      min: [1, 31, 51, 71, 81, 91],
      max: [30, 50, 70, 80, 90, 100],
    },
    format_type: "number",
    search_value: [
      "percent_financed:[{min_financed} TO {max_financed}]",
    ],
    value_prefix: "",
    value_suffix : "%",
    values: [
      {
        name: "Any",
        filter: "",
        dropdown_name: "Any",
        search_value: "",
      },
      {
        name: "Has Financing",
        filter: "has-financing",
        dropdown_name: "Has Financing",
        search_value: "[.01 TO 100]",
      },
      {
        name: "90% to 100%",
        filter: "90-to-100",
        dropdown_name: "90% to 100%",
        search_value: "[90 TO 100]",
      },
      {
        name: "80% to 90%",
        filter: "80-to-90",
        dropdown_name: "80% to 90%",
        search_value: "[80 TO 90]",
      },
      {
        name: "70% to 80%",
        filter: "70-to-80",
        dropdown_name: "70% to 80%",
        search_value: "[70 TO 80]",
      },
      {
        name: "50% to 70%",
        filter: "50-to-70",
        dropdown_name: "50% to 70%",
        search_value: "[50 TO 70]",
      },
      {
        name: "30% to 50%",
        filter: "30-to-50",
        dropdown_name: "30% to 50%",
        search_value: "[30 TO 50]",
      },
      {
        name: "Less than 30%",
        filter: "1-to-30",
        dropdown_name: "Less than 30%",
        search_value: "[1 TO 30]",
      },
    ],
  },
  {
    name: "Owner Type",
    show_name: true,
    search_key: "type",
    values: [
      {
        name: "Any",
        filter: "",
        dropdown_name: "Any",
        search_value: "",
      },
      {
        name: "Original Owner",
        filter: "original",
        dropdown_name: "Original Owner",
        search_value: "* AND owner:* AND sponsored_sale:false",
      },
      {
        name: "Corporate Owner",
        filter: "corporate",
        dropdown_name: "Corporate Owner",
        search_value:
          "* AND owner:(*llc *inc *corp *trust *l.p. *authority *associates *company *l.l.c)",
      },
    ],
  },

  {
    name: "Sale Includes",
    show_name: true,
    search_key: "parcels_property_types",
    values: [
      {
        name: "Any",
        filter: "",
        dropdown_name: "Any",
        search_value: "",
      },
      {
        name: "Includes Parking",
        filter: "parking",
        dropdown_name: "Includes Parking",
        search_value: "ps",
      },
      {
        name: "Includes Storage",
        filter: "storage",
        dropdown_name: "Includes Storage",
        search_value: "sr",
      },
      {
        name: "Includes Parking & Storage",
        filter: "parking-storage",
        dropdown_name: "Includes Parking & Storage",
        search_value: "ps AND parcels_property_types:sr",
      },
      {
        name: "Excludes Parking",
        filter: "exclude-parking",
        dropdown_name: "Excludes Parking",
        search_value: "* AND -parcels_property_types:ps",
      },
      {
        name: "Excludes Storage",
        filter: "exclude-storage",
        dropdown_name: "Excludes Storage",
        search_value: "* AND -parcels_property_types:sr",
      },
      {
        name: "Excludes Parking & Storage",
        filter: "exclude-parking-storage",
        dropdown_name: "Excludes Parking & Storage",
        search_value:
          "* AND -parcels_property_types:ps AND -parcels_property_types:sr",
      },
    ],
  },
  {
    name: "Buyer Name",
    show_name: true,
    search_key: "owner",
    text_filter: true,
  },
  {
    name: "Seller Name",
    show_name: true,
    search_key: "seller",
    text_filter: true,
  },
  {
    name: "Lender Name",
    show_name: true,
    search_key: "lender",
    text_filter: true,
  },
];

export const _financingFilters = [
  {
    name: "Doc Type",
    show_name: true,
    search_key: "doc_type",
    multi_filter: true,
    values: [
      {
        name: "Any",
        filter: "",
        dropdown_name: "Any",
        search_value: "",
      },
      {
        name: "Mortgage",
        filter: "mtge",
        dropdown_name: "Mortgage",
        search_value: "mtge",
      },
      {
        name: "Agreement / Modification",
        filter: "agmt",
        dropdown_name: "Agreement / Modification",
        search_value: "agmt",
      },
      {
        name: "Assignment",
        filter: "asst",
        dropdown_name: "Assignment",
        search_value: "asst",
      },
      {
        name: "Satisfaction",
        filter: "sat",
        dropdown_name: "Satisfaction",
        search_value: "sat",
      },
      {
        name: "Consolidation (CDEC)",
        filter: "cdec",
        dropdown_name: "Consolidation (CDEC)",
        search_value: "cdec",
      },
      {
        name: "Assignment Declaration (ADEC)",
        filter: "adec",
        dropdown_name: "Assignment Declaration (ADEC)",
        search_value: "adec",
      },
      {
        name: "Assignment of Leases & Rents",
        filter: "al&r",
        dropdown_name: "Assignment of Leases & Rents",
        search_value: "al\\&r",
      },
      {
        name: "Mortgage Consolidation",
        filter: "mcon",
        dropdown_name: "Mortgage Consolidation",
        search_value: "mcon",
      },
    ],
  },
  {
    name: "Recorded Date",
    show_name: true,
    search_key: ["min_recorded_date", "max_recorded_date"],
    date_filter: true,
    search_value: ["recorded_datetime:[{min_recorded_date} TO {max_recorded_date}]"],
  },
  {
    name: "Document Date",
    show_name: true,
    search_key: ["min_document_date", "max_document_date"],
    date_filter: true,
    search_value: ["document_date:[{min_document_date} TO {max_document_date}]"],
  },
  {
    name: "Amount",
    show_name: true,
    value_contains_key: true,
    filter_key: "document_amt",
    format_type: "number",
    search_key: ["min_document_amt", "max_document_amt"],
    price_filter: true,
    search_value: ["document_amt:[{min_document_amt} TO {max_document_amt}]"],
  },
  {
    name: "Lender",
    show_name: true,
    search_key: "party_2",
    text_filter: true,
  },
  {
    name: "Borrower",
    show_name: true,
    search_key: "party_1",
    text_filter: true,
  },
];

export const _reportFilters = [
  {
    name: "Share Type",
    show_name: true,
    search_key: "share_type",
    values: [
      {
        name: "Any",
        filter: "",
        dropdown_name: "Any",
        search_value: ""
      },
      {
        name: "Projects",
        filter: "projects",
        dropdown_name: "Projects",
        search_value: {"$and" : [ {"report_type" : "single-project"} ]}
      },
      {
        name: "Buildings",
        filter: "buildings",
        dropdown_name: "Buildings",
        search_value: {"$and" : [ {"report_type" : "existing-building"} ]}
      },
      {
        name: "Collections",
        filter: "collections",
        dropdown_name: "Collections",
        search_value: {"report_type" : {"$in" : ["comp", "grid"]}},
      }	
    ]
  }];
  
  
  export const _permitFilters = [
    {
      name: "Filing Date",
      show_name: true,
      search_key: ["filed_min_date", "filed_max_date"],
      filter_key: 'filing_date',
      date_filter: true,
      search_value: ["filing_date:[{filed_min_date} TO {filed_min_date}]"],
    },
    {
      name: "Issuance Date",
      show_name: true,
      search_key: ["min_date", "max_date"],
      filter_key: 'issuance_date',
      date_filter: true,
      search_value: ["issuance_date:[{min_date} TO {max_date}]"],
    },
    {
      name: "Job Type",
      show_name: true,
      search_key: "job_type",
      multi_filter: true,
      values: [
        {
          name: "Any",
          filter: "",
          dropdown_name: "Any",
          search_value: "",
        },
        {
          name: "New Building",
          filter: "nb",
          dropdown_name: "New Building",
          search_value: "(nb 5 6)",
        },
        {
          name: "Demolition",
          filter: "dm",
          dropdown_name: "Demolition",
          search_value: "(dm 7)",
        },
        {
          name: "Major Alteration",
          filter: "a1",
          dropdown_name: "Major Alteration",
          search_value: "(a1 4)",
        },
        {
          name: "Minor Alteration",
          filter: "a3",
          dropdown_name: "Minor Alteration",
          search_value: "(a3 alt 1)",
        }
      ],
    },
    {
      name: "Work Type",
      show_name: true,
      search_key: "work_type",
      multi_filter: true,
      values: [
        {
          name: "Any",
          filter: "",
          dropdown_name: "Any",
          search_value: "",
        },
        {
          name: "General Construction",
          filter: "gc",
          dropdown_name: "General Construction",
          search_value: "(gc *general*const*)",
        },
        {
          name: "Plumbing",
          filter: "pl",
          dropdown_name: "Plumbing",
          search_value: "(pl *plumbing*)",
        },
        {
          name: "Construction Equipment",
          filter: "eq",
          dropdown_name: "Construction Equipment",
          search_value: "(eq */eq* *eq/*)",
        },
        {
          name: "Foundation/Earthwork",
          filter: "fo",
          dropdown_name: "Foundation/Earthwork",
          search_value: "(fo */fo* *fo/* foundation ea)",
        },
        {
          name: "Sidewalk Shed",
          filter: "sh",
          dropdown_name: "Sidewalk Shed",
          search_value: "(sh */sh* *sh/* sidewalk*shed)",
        },
        {
          name: "Scaffolding",
          filter: "sf",
          dropdown_name: "Scaffolding",
          search_value: "(sf */sf* *sf/* supported*scaffold sc */sc *sc/)",
        },
        {
          name: "Boiler",
          filter: "bl",
          dropdown_name: "Boiler",
          search_value: "(bl */bl* *bl/* boiler)",
        },
        {
          name: "Construction Fence",
          filter: "fn",
          dropdown_name: "Construction Fence",
          search_value: "(fn */fn *fn/* construction*fence)",
        },
        {
          name: "Mechanical Systems",
          filter: "mh",
          dropdown_name: "Mechanical Systems",
          search_value: "(mh */md *md/* mechanical*systems)",
        },
        {
          name: "Standpipe",
          filter: "sd",
          dropdown_name: "Standpipe",
          search_value: "(sd */sd *sd/* standpipe)",
        },
        
        {
          name: "Fire Suppression",
          filter: "fp",
          dropdown_name: "Fire Suppression",
          search_value: "(fp */fp* *fp/* fire*suppression)",
        },
        {
          name: "Sprinklers",
          filter: "sp",
          dropdown_name: "Sprinklers",
          search_value: "(*/sp* *sp/* sp sprinklers)",
        },
        {
          name: "Fuel Storage",
          filter: "fs",
          dropdown_name: "Fuel Storage",
          search_value: "(fs */fs* *fs/* fuel*storage)",
        },
        {
          name: "Fuel Burning",
          filter: "fb",
          dropdown_name: "Fuel Burning",
          search_value: "(fb */fb* *fb/* fuel*burning)",
        },
        {
          name: "Sign",
          filter: "sg",
          dropdown_name: "Sign",
          search_value: "(sg */sg* *sg/* *sign*)",
        },
        {
          name: "Electrical",
          filter: "el",
          dropdown_name: "Electrical",
          search_value: "(el */el* *el/* *electrical*)",
        },
        {
          name: "Curb Cut",
          filter: "cc",
          dropdown_name: "Curb Cut",
          search_value: "(cc */cc* *cc/* curb*cut)",
        },
        {
          name: "Protection and Mechanical Methods",
          filter: "pm",
          dropdown_name: "Protection and Mechanical Methods",
          search_value: "(pm pmm */pm* *pm/*)",
        }
      ],
    },
    {
      name: "Status",
      show_name: true,
      search_key: "filing_status",
      multi_filter: true,
      hide_issuance:false,
      values: [
        {
          name: "Any",
          filter: "",
          dropdown_name: "Any",
          search_value: "",
        },
        {
          name: "Assigned",
          filter: "assign",
          dropdown_name: "Assigned",
          search_value: "(3 25 33 67 84 7)",
        },
        {
          name: "Review",
          filter: "review",
          dropdown_name: "Review",
          search_value: "(4 26 5 68 13 2 71 85 24 25 8 47 10 11 50 52 72)",
        },
        {
          name: "Objections",
          filter: "objections",
          dropdown_name: "Objections",
          search_value: "(19 70 8 86 16 14)",
        },
        {
          name: "Approved",
          filter: "approved",
          dropdown_name: "Approved",
          search_value: "(6 8 16 37 13 102 15 52)",
        },
        {
          name: "Issued - Initial",
          filter: "issued-initial",
          dropdown_name: "Issued - Initial",
          search_value: "(initial)",
        },
        {
          name: "Issued - Renewal",
          filter: "issued-renewal",
          dropdown_name: "Issued - Renewal",
          search_value: "(renewal)",
        }
      ],
    },
    {
      name: "Applicant Company Name",
      show_name: true,
      search_key: "applicant_business_name",
      text_filter: true,
      hide_issuance:false
    },
    {
      name: "Applicant Contact Name",
      show_name: true,
      search_key: "applicant_contact_name",
      search_fields: ["applicant_first_name", "applicant_first_name"],
      text_filter: true,
      hide_issuance:false
    },
    {
      name: "Filing Rep Company Name",
      show_name: true,
      search_key: "filing_applicant_business_name",
      text_filter: true,
      hide_issuance:false
    },
    {
      name: "Filing Rep Contact Name",
      show_name: true,
      search_key: "filing_applicant_contact_name",
      search_fields: ["filing_applicant_irst_name", "filing_applicant_first_name"],
      text_filter: true,
      hide_issuance:true
    },
    {
      name: "Permittee Company Name",
      show_name: true,
      search_key: "permittee_business_name",
      text_filter: true,
    },
    {
      name: "Permittee Contact Name",
      show_name: true,
      search_key: "permittee_contact_name",
      search_fields: ["permittee_first_name", "permittee_last_name"],
      text_filter: true,
    },
    {
      name: "Owner Company Name",
      show_name: true,
      search_key: "owner_business_name",
      text_filter: true,
    },
    {
      name: "Owner Contact Name",
      show_name: true,
      search_key: "owner_contact_name",
      search_fields: ["owner_first_name","owner_last_name"],
      text_filter: true,
    },
    // Building attribute filters — applied against we3-buildings via a Solr join
    // ({!join from=alternate_keys fromIndex=we3-buildings to=building}) in
    // UnitsSearchTable, since these fields live on the building, not the permit.
	{
		name: "Building Class",
		show_name: true,
		search_key: "property_type_filter",
		filter_type: "building",
		hierarchical_filter: true,
		no_key: true,
		minWidth: 200,
		values: [
			// === RESIDENTIAL ===
			{
				name: "Residential", filter: "residential", dropdown_name: "Residential", search_value: "",
				children: [
					{
						name: "Single Family", filter: "Residential__SingleFamily", dropdown_name: "Single Family", search_value: "",
						children: [
							{ name: "Cape Cod", filter: "A0", dropdown_name: "Cape Cod (A0)", search_value: "building_class:(A0)" },
							{ name: "Two Stories Detached", filter: "A1", dropdown_name: "Two Stories Detached (A1)", search_value: "building_class:(A1)" },
							{ name: "One Story - Permanent Living Quarter", filter: "A2", dropdown_name: "One Story - Permanent Living Quarter (A2)", search_value: "building_class:(A2)" },
							{ name: "Large Suburban Residence", filter: "A3", dropdown_name: "Large Suburban Residence (A3)", search_value: "building_class:(A3)" },
							{ name: "City Residence One Family", filter: "A4", dropdown_name: "City Residence One Family (A4)", search_value: "building_class:(A4)" },
							{ name: "One Family Attached or Semi-Detached", filter: "A5", dropdown_name: "One Family Attached or Semi-Detached (A5)", search_value: "building_class:(A5)" },
							{ name: "Summer Cottage", filter: "A6", dropdown_name: "Summer Cottage (A6)", search_value: "building_class:(A6)" },
							{ name: "Bungalow Colony", filter: "A8", dropdown_name: "Bungalow Colony (A8)", search_value: "building_class:(A8)" },
							{ name: "Miscellaneous One Family", filter: "A9", dropdown_name: "Miscellaneous One Family (A9)", search_value: "building_class:(A9)" },
						]
					},
					{
						name: "Townhouse/Rowhouse", filter: "Residential__TownhouseRowhouse", dropdown_name: "Townhouse/Rowhouse", search_value: "",
						children: [
							{ name: "Mansion Type or Town House", filter: "A7", dropdown_name: "Mansion Type or Town House (A7)", search_value: "building_class:(A7)" },
						]
					},
					{
						name: "2-4 Family", filter: "Residential__Family", dropdown_name: "2-4 Family", search_value: "",
						children: [
							{ name: "Two Family Brick", filter: "B1", dropdown_name: "Two Family Brick (B1)", search_value: "building_class:(B1)" },
							{ name: "Two Family Frame", filter: "B2", dropdown_name: "Two Family Frame (B2)", search_value: "building_class:(B2)" },
							{ name: "Two Family Converted from One Family", filter: "B3", dropdown_name: "Two Family Converted from One Family (B3)", search_value: "building_class:(B3)" },
							{ name: "Miscellaneous Two Family", filter: "B9", dropdown_name: "Miscellaneous Two Family (B9)", search_value: "building_class:(B9)" },
							{ name: "Three Families", filter: "C0", dropdown_name: "Three Families (C0)", search_value: "building_class:(C0)" },
							{ name: "Four Families", filter: "C3", dropdown_name: "Four Families (C3)", search_value: "building_class:(C3)" },
						]
					},
					{
						name: "Co-op Building", filter: "Residential__CoopBuilding", dropdown_name: "Co-op Building", search_value: "",
						children: [
							{ name: "Walk-up Co-op Building; Loft/Warehouse", filter: "XC8", dropdown_name: "Walk-up Co-op Bldg; Loft/Warehouse (XC8)", search_value: "building_class:(XC8)" },
							{ name: "Elevator Co-op Building; Loft/Warehouse", filter: "XD0", dropdown_name: "Elevator Co-op Bldg; Loft/Warehouse (XD0)", search_value: "building_class:(XD0)" },
							{ name: "Elevator Apartments Cooperatives Building", filter: "XD4", dropdown_name: "Elevator Apts Co-op Bldg (XD4)", search_value: "building_class:(XD4)" },
							{ name: "Walk-up Cooperative Building", filter: "XC6", dropdown_name: "Walk-up Co-op Bldg (XC6)", search_value: "building_class:(XC6)" },
							{ name: "Walk-Up Co-Op Apartments <11 Units", filter: "XCC", dropdown_name: "Walk-Up Co-Op Apts <11 Units (XCC)", search_value: "building_class:(XCC)" },
							{ name: "Elevator Co-op Apartment <11 Units", filter: "XDC", dropdown_name: "Elevator Co-op Apt <11 Units (XDC)", search_value: "building_class:(XDC)" },
						]
					},
					{
						name: "Condo Building", filter: "Residential__CondoBuilding", dropdown_name: "Condo Building", search_value: "",
						children: [
							{ name: "Residential Building (Mixed Residential Condo Building)", filter: "RD", dropdown_name: "Mixed Residential Condo Bldg (RD)", search_value: "building_class:(RD)" },
							{ name: "Special Condominium Billing Lot", filter: "R0", dropdown_name: "Special Condo Billing Lot (R0)", search_value: "building_class:(R0)" },
						]
					},
					{
						name: "Other Residential", filter: "Residential__OtherResidential", dropdown_name: "Other Residential", search_value: "",
						children: [
							{ name: "Old Law Tenement", filter: "C4", dropdown_name: "Old Law Tenement (C4)", search_value: "building_class:(C4)" },
							{ name: "Terraces/Gardens/Cabanas", filter: "RT", dropdown_name: "Terraces/Gardens/Cabanas (RT)", search_value: "building_class:(RT)" },
						]
					},
				]
			},
			// === MULTI-FAMILY ===
			{
				name: "Multi-Family", filter: "multi-family", dropdown_name: "Multi-Family", search_value: "",
				children: [
					{
						name: "5+ Family", filter: "MultiFamily__Family", dropdown_name: "5+ Family", search_value: "",
						children: [
							{ name: "Over Six Families without Stores", filter: "C1", dropdown_name: "Over Six Families without Stores (C1)", search_value: "building_class:(C1)" },
							{ name: "Five to Six Families", filter: "C2", dropdown_name: "Five to Six Families (C2)", search_value: "building_class:(C2)" },
						]
					},
					{
						name: "Apartments", filter: "MultiFamily__Apartments", dropdown_name: "Apartments", search_value: "",
						children: [
							{ name: "Elevator Apartment - Semi-fireproof without Stores", filter: "D1", dropdown_name: "Elevator Apt - Semi-fireproof (D1)", search_value: "building_class:(D1)" },
							{ name: "Elevator Apartment - Artists in Residence", filter: "D2", dropdown_name: "Elevator Apt - Artists in Residence (D2)", search_value: "building_class:(D2)" },
							{ name: "Elevator Apartment - Fireproof without Stores", filter: "D3", dropdown_name: "Elevator Apt - Fireproof (D3)", search_value: "building_class:(D3)" },
							{ name: "Elevator Apartment - Converted", filter: "D5", dropdown_name: "Elevator Apt - Converted (D5)", search_value: "building_class:(D5)" },
							{ name: "Elevator Apartment - Luxury Type", filter: "D8", dropdown_name: "Elevator Apt - Luxury Type (D8)", search_value: "building_class:(D8)" },
							{ name: "Elevator Apartment - Miscellaneous", filter: "D9", dropdown_name: "Elevator Apt - Miscellaneous (D9)", search_value: "building_class:(D9)" },
							{ name: "Garden Apartments", filter: "C9", dropdown_name: "Garden Apartments (C9)", search_value: "building_class:(C9)" },
							{ name: "Walk-Up Apartments <11 Units", filter: "CB", dropdown_name: "Walk-Up Apts <11 Units (CB)", search_value: "building_class:(CB)" },
							{ name: "Elevator Apartments <11 Units", filter: "DB", dropdown_name: "Elevator Apts <11 Units (DB)", search_value: "building_class:(DB)" },
						]
					},
					{
						name: "Dormitories", filter: "MultiFamily__Dormitories", dropdown_name: "Dormitories", search_value: "",
						children: [
							{ name: "Dormitory", filter: "H8", dropdown_name: "Dormitory (H8)", search_value: "building_class:(H8)" },
						]
					},
					{
						name: "Public Housing/Subsidized", filter: "MultiFamily__PublicHousingSubsidized", dropdown_name: "Public Housing/Subsidized", search_value: "",
						children: [
							{ name: "SRO - Affordable Housing", filter: "HR", dropdown_name: "SRO - Affordable Housing (HR)", search_value: "building_class:(HR)" },
						]
					},
					{
						name: "Mobile Homes in Parks", filter: "MultiFamily__MobileHomesinParks", dropdown_name: "Mobile Homes in Parks", search_value: "",
						children: [
							{ name: "Mobile Homes/Trailer Parks", filter: "CM", dropdown_name: "Mobile Homes/Trailer Parks (CM)", search_value: "building_class:(CM)" },
						]
					},
				]
			},
			// === VACANT LAND ===
			{
				name: "Vacant Land", filter: "vacant-land", dropdown_name: "Vacant Land", search_value: "",
				children: [
					{
						name: "Vacant Residential", filter: "VacantLand__VacantResidential", dropdown_name: "Vacant Residential", search_value: "",
						children: [
							{ name: "Zoned Residential - Not Manhattan", filter: "V0", dropdown_name: "Zoned Residential - Not Manhattan (V0)", search_value: "building_class:(V0)" },
							{ name: "Zoned Primarily Residential - Not Manhattan", filter: "V3", dropdown_name: "Zoned Primarily Residential (V3)", search_value: "building_class:(V3)" },
							{ name: "Community Garden Zoned Residential", filter: "VG", dropdown_name: "Community Garden Zoned Residential (VG)", search_value: "building_class:(VG)" },
						]
					},
					{
						name: "Vacant Commercial", filter: "VacantLand__VacantCommercial", dropdown_name: "Vacant Commercial", search_value: "",
						children: [
							{ name: "Zoned Commercial or Manhattan Residential", filter: "V1", dropdown_name: "Zoned Commercial or Manhattan Res (V1)", search_value: "building_class:(V1)" },
							{ name: "Zoned Commercial Adjacent to Tax Class 1", filter: "V2", dropdown_name: "Zoned Commercial Adj Tax Class 1 (V2)", search_value: "building_class:(V2)" },
							{ name: "Community Garden Zoned Commercial", filter: "VC", dropdown_name: "Community Garden Zoned Commercial (VC)", search_value: "building_class:(VC)" },
						]
					},
					{
						name: "Vacant Government Owned", filter: "VacantLand__VacantGovernmentOwned", dropdown_name: "Vacant Government Owned", search_value: "",
						children: [
							{ name: "Port Authority of NY and NJ", filter: "V7", dropdown_name: "Port Authority of NY and NJ (V7)", search_value: "building_class:(V7)" },
							{ name: "New York State or US Government", filter: "V8", dropdown_name: "New York State or US Government (V8)", search_value: "building_class:(V8)" },
							{ name: "Police or Fire Department", filter: "V4", dropdown_name: "Police or Fire Department (V4)", search_value: "building_class:(V4)" },
						]
					},
					{
						name: "Other Vacant", filter: "VacantLand__OtherVacant", dropdown_name: "Other Vacant", search_value: "",
						children: [
							{ name: "Open Space", filter: "Q0", dropdown_name: "Open Space (Q0)", search_value: "building_class:(Q0)" },
							{ name: "School Site or Yard", filter: "V5", dropdown_name: "School Site or Yard (V5)", search_value: "building_class:(V5)" },
							{ name: "Library, Hospital or Museum", filter: "V6", dropdown_name: "Library, Hospital or Museum (V6)", search_value: "building_class:(V6)" },
							{ name: "Miscellaneous Vacant Land", filter: "V9", dropdown_name: "Miscellaneous Vacant Land (V9)", search_value: "building_class:(V9)" },
						]
					},
				]
			},
			// === MIXED USE ===
			{
				name: "Mixed Use", filter: "mixed-use", dropdown_name: "Mixed Use", search_value: "",
				children: [
					{
						name: "Small Residential & Retail/Office", filter: "MixedUse__SmallResidentialRetailOffice", dropdown_name: "Small Res & Retail/Office", search_value: "",
						children: [
							{ name: "Primarily One Family with Two Stores or Offices", filter: "S0", dropdown_name: "One Family w/ Two Stores/Offices (S0)", search_value: "building_class:(S0)" },
							{ name: "Primarily One Family with One Store or Office", filter: "S1", dropdown_name: "One Family w/ One Store/Office (S1)", search_value: "building_class:(S1)" },
							{ name: "Primarily Two Family with One Store or Office", filter: "S2", dropdown_name: "Two Family w/ One Store/Office (S2)", search_value: "building_class:(S2)" },
							{ name: "Primarily Three Family with One Store or Office", filter: "S3", dropdown_name: "Three Family w/ One Store/Office (S3)", search_value: "building_class:(S3)" },
							{ name: "Primarily Four Family with One Store or Office", filter: "S4", dropdown_name: "Four Family w/ One Store/Office (S4)", search_value: "building_class:(S4)" },
							{ name: "Single or Multiple Dwelling with Stores or Offices", filter: "S9", dropdown_name: "Dwelling w/ Stores or Offices (S9)", search_value: "building_class:(S9)" },
						]
					},
					{
						name: "Multi-Family & Retail/Office", filter: "MixedUse__MultiFamilyRetailOffice", dropdown_name: "Multi-Family & Retail/Office", search_value: "",
						children: [
							{ name: "Office with Apartments Only", filter: "O8", dropdown_name: "Office with Apartments Only (O8)", search_value: "building_class:(O8)" },
							{ name: "Primarily Five to Six Family with One Store", filter: "S5", dropdown_name: "Five to Six Family w/ Store (S5)", search_value: "building_class:(S5)" },
							{ name: "Elevator Apartment - Fireproof with Stores", filter: "D6", dropdown_name: "Elevator Apt - Fireproof w/ Stores (D6)", search_value: "building_class:(D6)" },
							{ name: "Elevator Apartment - Semi-Fireproof with Stores", filter: "D7", dropdown_name: "Elevator Apt - Semi-Fireproof w/ Stores (D7)", search_value: "building_class:(D7)" },
							{ name: "Walk-up Apartment Over Six Families with Stores", filter: "C7", dropdown_name: "Walk-up Apt 6+ Families w/ Stores (C7)", search_value: "building_class:(C7)" },
						]
					},
					{
						name: "Other Residential & Commercial", filter: "MixedUse__OtherResidentialCommercial", dropdown_name: "Other Res & Commercial", search_value: "",
						children: [
							{ name: "Mixed Residential & Commercial Building", filter: "RM", dropdown_name: "Mixed Res & Commercial Bldg (RM)", search_value: "building_class:(RM)" },
							{ name: "Mixed Residential & Commercial Building", filter: "RX", dropdown_name: "Mixed Res & Commercial Bldg (RX)", search_value: "building_class:(RX)" },
							{ name: "Commercial Building (Mixed Commercial Condo)", filter: "RC", dropdown_name: "Commercial Bldg - Mixed Condo (RC)", search_value: "building_class:(RC)" },
						]
					},
					{
						name: "Residential & Industrial", filter: "MixedUse__ResidentialIndustrial", dropdown_name: "Res & Industrial", search_value: "",
						children: [
							{ name: "Mixed Residential & Warehouse", filter: "RZ", dropdown_name: "Mixed Residential & Warehouse (RZ)", search_value: "building_class:(RZ)" },
						]
					},
					{
						name: "Commercial & Industrial", filter: "MixedUse__CommercialIndustrial", dropdown_name: "Commercial & Industrial", search_value: "",
						children: [
							{ name: "Mixed Warehouse/Factory/Industrial & Commercial", filter: "RI", dropdown_name: "Mixed Warehouse/Factory & Commercial (RI)", search_value: "building_class:(RI)" },
						]
					},
					{
						name: "Other Mixed Use", filter: "MixedUse__OtherMixedUse", dropdown_name: "Other Mixed Use", search_value: "",
						children: [
							{ name: "Cultural, Medical, Educational, etc.", filter: "RA", dropdown_name: "Cultural, Medical, Educational (RA)", search_value: "building_class:(RA)" },
						]
					},
				]
			},
			// === COMMERCIAL CONDOS ===
			{
				name: "Commercial Condos", filter: "commercial-condos", dropdown_name: "Commercial Condos", search_value: "",
				children: [
					{
						name: "Other Condos", filter: "CommercialCondos__OtherCondos", dropdown_name: "Other Condos", search_value: "",
						children: [
							{ name: "Condo - Commercial Unit of 1-3 Unit Building", filter: "R7", dropdown_name: "Condo - Commercial 1-3 Unit Bldg (R7)", search_value: "building_class:(R7)" },
							{ name: "Condo - Commercial Unit of 2-10 Unit Building", filter: "R8", dropdown_name: "Condo - Commercial 2-10 Unit Bldg (R8)", search_value: "building_class:(R8)" },
						]
					},
				]
			},
			// === OFFICE ===
			{
				name: "Office", filter: "office", dropdown_name: "Office", search_value: "",
				children: [
					{
						name: "Office Building", filter: "Office__OfficeBuilding", dropdown_name: "Office Building", search_value: "",
						children: [
							{ name: "Office Only - 1 Story", filter: "O1", dropdown_name: "Office Only - 1 Story (O1)", search_value: "building_class:(O1)" },
							{ name: "Office Only 2-6 Stories", filter: "O2", dropdown_name: "Office Only 2-6 Stories (O2)", search_value: "building_class:(O2)" },
							{ name: "Office Only 7-19 Stories", filter: "O3", dropdown_name: "Office Only 7-19 Stories (O3)", search_value: "building_class:(O3)" },
							{ name: "Office Only 20+ Stories", filter: "O4", dropdown_name: "Office Only 20+ Stories (O4)", search_value: "building_class:(O4)" },
							{ name: "Office with Commercial - 1 to 6 Stories", filter: "O5", dropdown_name: "Office w/ Commercial 1-6 Stories (O5)", search_value: "building_class:(O5)" },
							{ name: "Office with Commercial 7-19 Stories", filter: "O6", dropdown_name: "Office w/ Commercial 7-19 Stories (O6)", search_value: "building_class:(O6)" },
							{ name: "Professional Buildings/Funeral Homes", filter: "O7", dropdown_name: "Professional Bldgs/Funeral Homes (O7)", search_value: "building_class:(O7)" },
							{ name: "Office Space", filter: "RB", dropdown_name: "Office Space (RB)", search_value: "building_class:(RB)" },
						]
					},
					{
						name: "Bank/Credit Unions", filter: "Office__BankCreditUnions", dropdown_name: "Bank/Credit Unions", search_value: "",
						children: [
							{ name: "Banking Facilities with or without Parking", filter: "K7", dropdown_name: "Banking Facilities (K7)", search_value: "building_class:(K7)" },
							{ name: "Miscellaneous and Old Style Bank Buildings", filter: "O9", dropdown_name: "Old Style Bank Buildings (O9)", search_value: "building_class:(O9)" },
						]
					},
					{
						name: "Media/Technology", filter: "Office__MediaTechnology", dropdown_name: "Media/Technology", search_value: "",
						children: [
							{ name: "Television Studio", filter: "J6", dropdown_name: "Television Studio (J6)", search_value: "building_class:(J6)" },
						]
					},
					{
						name: "Government", filter: "Office__Government", dropdown_name: "Government", search_value: "",
						children: [
							{ name: "Court House", filter: "Z1", dropdown_name: "Court House (Z1)", search_value: "building_class:(Z1)" },
						]
					},
				]
			},
			// === RETAIL ===
			{
				name: "Retail", filter: "retail", dropdown_name: "Retail", search_value: "",
				children: [
					{
						name: "Store", filter: "Retail__Store", dropdown_name: "Store", search_value: "",
						children: [
							{ name: "Multi-Story Department Store", filter: "K3", dropdown_name: "Multi-Story Department Store (K3)", search_value: "building_class:(K3)" },
							{ name: "Big Box Retail", filter: "K8", dropdown_name: "Big Box Retail (K8)", search_value: "building_class:(K8)" },
							{ name: "Miscellaneous Store Building", filter: "K9", dropdown_name: "Miscellaneous Store Building (K9)", search_value: "building_class:(K9)" },
						]
					},
					{
						name: "Shopping Center", filter: "Retail__ShoppingCenter", dropdown_name: "Shopping Center", search_value: "",
						children: [
							{ name: "Shopping Center with or without Parking", filter: "K6", dropdown_name: "Shopping Center (K6)", search_value: "building_class:(K6)" },
						]
					},
					{
						name: "Showroom", filter: "Retail__Showroom", dropdown_name: "Showroom", search_value: "",
						children: [
							{ name: "Car Sales/Rental with Showroom", filter: "G8", dropdown_name: "Car Sales/Rental with Showroom (G8)", search_value: "building_class:(G8)" },
						]
					},
					{
						name: "Other Retail", filter: "Retail__OtherRetail", dropdown_name: "Other Retail", search_value: "",
						children: [
							{ name: "One Story Retail Building", filter: "K1", dropdown_name: "One Story Retail Building (K1)", search_value: "building_class:(K1)" },
							{ name: "Multi-Story Retail Building", filter: "K2", dropdown_name: "Multi-Story Retail Building (K2)", search_value: "building_class:(K2)" },
							{ name: "Predominant Retail with Other Uses", filter: "K4", dropdown_name: "Predominant Retail w/ Other Uses (K4)", search_value: "building_class:(K4)" },
							{ name: "Retail Space", filter: "RK", dropdown_name: "Retail Space (RK)", search_value: "building_class:(RK)" },
						]
					},
				]
			},
			// === INDUSTRIAL ===
			{
				name: "Industrial", filter: "industrial", dropdown_name: "Industrial", search_value: "",
				children: [
					{
						name: "Manufacturing/Processing", filter: "Industrial__ManufacturingProcessing", dropdown_name: "Manufacturing/Processing", search_value: "",
						children: [
							{ name: "Factory - Heavy Manufacturing (Fireproof)", filter: "F1", dropdown_name: "Heavy Manufacturing Fireproof (F1)", search_value: "building_class:(F1)" },
							{ name: "Factory - Special Construction (Fireproof)", filter: "F2", dropdown_name: "Special Construction Fireproof (F2)", search_value: "building_class:(F2)" },
							{ name: "Factory - Industrial Semi-Fireproof", filter: "F4", dropdown_name: "Industrial Semi-Fireproof (F4)", search_value: "building_class:(F4)" },
							{ name: "Factory - Light Manufacturing", filter: "F5", dropdown_name: "Light Manufacturing (F5)", search_value: "building_class:(F5)" },
							{ name: "Factory - Tank Farms", filter: "F8", dropdown_name: "Tank Farms (F8)", search_value: "building_class:(F8)" },
							{ name: "Factory - Industrial Miscellaneous", filter: "F9", dropdown_name: "Industrial Miscellaneous (F9)", search_value: "building_class:(F9)" },
						]
					},
					{
						name: "Warehouse", filter: "Industrial__Warehouse", dropdown_name: "Warehouse", search_value: "",
						children: [
							{ name: "Fireproof Warehouse", filter: "E1", dropdown_name: "Fireproof Warehouse (E1)", search_value: "building_class:(E1)" },
							{ name: "Contractors Warehouse", filter: "E2", dropdown_name: "Contractors Warehouse (E2)", search_value: "building_class:(E2)" },
							{ name: "Miscellaneous Warehouse", filter: "E9", dropdown_name: "Miscellaneous Warehouse (E9)", search_value: "building_class:(E9)" },
							{ name: "Warehouse/Factory/Industrial", filter: "RW", dropdown_name: "Warehouse/Factory/Industrial (RW)", search_value: "building_class:(RW)" },
						]
					},
					{
						name: "Self-Storage", filter: "Industrial__SelfStorage", dropdown_name: "Self-Storage", search_value: "",
						children: [
							{ name: "Self-Storage Warehouse", filter: "E7", dropdown_name: "Self-Storage Warehouse (E7)", search_value: "building_class:(E7)" },
							{ name: "Non-Business Storage Space", filter: "RS", dropdown_name: "Non-Business Storage Space (RS)", search_value: "building_class:(RS)" },
						]
					},
					{
						name: "Automotive", filter: "Industrial__Automotive", dropdown_name: "Automotive", search_value: "",
						children: [
							{ name: "Auto Body/Collision or Auto Repair", filter: "G2", dropdown_name: "Auto Body/Collision/Repair (G2)", search_value: "building_class:(G2)" },
							{ name: "Gas Station with Retail Store", filter: "G3", dropdown_name: "Gas Station w/ Retail Store (G3)", search_value: "building_class:(G3)" },
							{ name: "Gas Station with Service/Auto Repair", filter: "G4", dropdown_name: "Gas Station w/ Service/Repair (G4)", search_value: "building_class:(G4)" },
							{ name: "Gas Station Only", filter: "G5", dropdown_name: "Gas Station Only (G5)", search_value: "building_class:(G5)" },
							{ name: "Miscellaneous Garage", filter: "G9", dropdown_name: "Miscellaneous Garage (G9)", search_value: "building_class:(G9)" },
							{ name: "Car Sales/Rental without Showroom", filter: "GU", dropdown_name: "Car Sales/Rental w/o Showroom (GU)", search_value: "building_class:(GU)" },
							{ name: "Car Wash or Lubritorium Facility", filter: "GW", dropdown_name: "Car Wash or Lubritorium (GW)", search_value: "building_class:(GW)" },
						]
					},
				]
			},
			// === HOSPITALITY ===
			{
				name: "Hospitality", filter: "hospitality", dropdown_name: "Hospitality", search_value: "",
				children: [
					{
						name: "Hotel/Motel/Hostel/B&B", filter: "Hospitality__HotelMotelHostelBB", dropdown_name: "Hotel/Motel/Hostel/B&B", search_value: "",
						children: [
							{ name: "Luxury Hotel", filter: "H1", dropdown_name: "Luxury Hotel (H1)", search_value: "building_class:(H1)" },
							{ name: "Full Service Hotel", filter: "H2", dropdown_name: "Full Service Hotel (H2)", search_value: "building_class:(H2)" },
							{ name: "Limited Service Hotel", filter: "H3", dropdown_name: "Limited Service Hotel (H3)", search_value: "building_class:(H3)" },
							{ name: "Motel", filter: "H4", dropdown_name: "Motel (H4)", search_value: "building_class:(H4)" },
							{ name: "Hotel - Private Club, Luxury Type", filter: "H5", dropdown_name: "Hotel - Private Club Luxury (H5)", search_value: "building_class:(H5)" },
							{ name: "Apartment Hotel", filter: "H6", dropdown_name: "Apartment Hotel (H6)", search_value: "building_class:(H6)" },
							{ name: "Apartment Hotel - Cooperatively Owned", filter: "H7", dropdown_name: "Apartment Hotel - Co-op (H7)", search_value: "building_class:(H7)" },
							{ name: "Miscellaneous Hotel", filter: "H9", dropdown_name: "Miscellaneous Hotel (H9)", search_value: "building_class:(H9)" },
							{ name: "Boutique Hotel", filter: "HB", dropdown_name: "Boutique Hotel (HB)", search_value: "building_class:(HB)" },
							{ name: "Hostel", filter: "HH", dropdown_name: "Hostel (HH)", search_value: "building_class:(HH)" },
							{ name: "Hotel/Boatel", filter: "RH", dropdown_name: "Hotel/Boatel (RH)", search_value: "building_class:(RH)" },
							{ name: "Extended Stay/Suite", filter: "HS", dropdown_name: "Extended Stay/Suite (HS)", search_value: "building_class:(HS)" },
						]
					},
					{
						name: "Rooming/Boarding House", filter: "Hospitality__RoomingBoardingHouse", dropdown_name: "Rooming/Boarding House", search_value: "",
						children: [
							{ name: "Converted Dwellings or Rooming House", filter: "C5", dropdown_name: "Converted Dwellings/Rooming House (C5)", search_value: "building_class:(C5)" },
						]
					},
					{
						name: "Restaurant/Bar", filter: "Hospitality__RestaurantBar", dropdown_name: "Restaurant/Bar", search_value: "",
						children: [
							{ name: "Stand Alone Food Establishment", filter: "K5", dropdown_name: "Stand Alone Food Establishment (K5)", search_value: "building_class:(K5)" },
						]
					},
				]
			},
			// === ENTERTAINMENT/RECREATIONAL ===
			{
				name: "Entertainment/Recreational", filter: "entertainment", dropdown_name: "Entertainment/Recreational", search_value: "",
				children: [
					{
						name: "Parks", filter: "EntertainmentRecreational__Parks", dropdown_name: "Parks", search_value: "",
						children: [
							{ name: "Parks/Recreation Facilities", filter: "Q1", dropdown_name: "Parks/Recreation Facilities (Q1)", search_value: "building_class:(Q1)" },
							{ name: "Playground", filter: "Q2", dropdown_name: "Playground (Q2)", search_value: "building_class:(Q2)" },
						]
					},
					{
						name: "Country Club/Golf Course", filter: "EntertainmentRecreational__CountryClubGolfCourse", dropdown_name: "Country Club/Golf Course", search_value: "",
						children: [
							{ name: "Golf Course", filter: "Q5", dropdown_name: "Golf Course (Q5)", search_value: "building_class:(Q5)" },
						]
					},
					{
						name: "Marinas", filter: "EntertainmentRecreational__Marinas", dropdown_name: "Marinas", search_value: "",
						children: [
							{ name: "Marina/Yacht Club", filter: "Q8", dropdown_name: "Marina/Yacht Club (Q8)", search_value: "building_class:(Q8)" },
						]
					},
					{
						name: "Arts & Culture", filter: "EntertainmentRecreational__ArtsCulture", dropdown_name: "Arts & Culture", search_value: "",
						children: [
							{ name: "Theatre - Art Type Less than 400 Seats", filter: "J1", dropdown_name: "Theatre - Art Type <400 Seats (J1)", search_value: "building_class:(J1)" },
							{ name: "Theatre - Art Type More than 400 Seats", filter: "J2", dropdown_name: "Theatre - Art Type >400 Seats (J2)", search_value: "building_class:(J2)" },
							{ name: "Motion Picture Theatre with Balcony", filter: "J3", dropdown_name: "Motion Picture Theatre (J3)", search_value: "building_class:(J3)" },
							{ name: "Legitimate Theatre - Sole Use", filter: "J4", dropdown_name: "Legitimate Theatre (J4)", search_value: "building_class:(J4)" },
							{ name: "Theatre in Mixed-Use Building", filter: "J5", dropdown_name: "Theatre in Mixed-Use Bldg (J5)", search_value: "building_class:(J5)" },
							{ name: "Museum", filter: "P7", dropdown_name: "Museum (P7)", search_value: "building_class:(P7)" },
							{ name: "Library", filter: "P8", dropdown_name: "Library (P8)", search_value: "building_class:(P8)" },
							{ name: "Off Broadway Type Theatre", filter: "J7", dropdown_name: "Off Broadway Theatre (J7)", search_value: "building_class:(J7)" },
							{ name: "Multiplex Picture Theatre", filter: "J8", dropdown_name: "Multiplex Picture Theatre (J8)", search_value: "building_class:(J8)" },
							{ name: "Miscellaneous Theatre", filter: "J9", dropdown_name: "Miscellaneous Theatre (J9)", search_value: "building_class:(J9)" },
						]
					},
					{
						name: "Athletic Facilities", filter: "EntertainmentRecreational__AthleticFacilities", dropdown_name: "Athletic Facilities", search_value: "",
						children: [
							{ name: "Outdoor Pool", filter: "Q3", dropdown_name: "Outdoor Pool (Q3)", search_value: "building_class:(Q3)" },
							{ name: "Stadium, Race Track, Baseball Field", filter: "Q6", dropdown_name: "Stadium/Race Track/Baseball (Q6)", search_value: "building_class:(Q6)" },
							{ name: "Tennis Court", filter: "Q7", dropdown_name: "Tennis Court (Q7)", search_value: "building_class:(Q7)" },
							{ name: "Tennis Court, Pool, Shed, etc.", filter: "Z0", dropdown_name: "Tennis Court, Pool, Shed (Z0)", search_value: "building_class:(Z0)" },
						]
					},
					{
						name: "Lodges/Halls", filter: "EntertainmentRecreational__LodgesHalls", dropdown_name: "Lodges/Halls", search_value: "",
						children: [
							{ name: "Concert Hall", filter: "P1", dropdown_name: "Concert Hall (P1)", search_value: "building_class:(P1)" },
							{ name: "Lodge Room", filter: "P2", dropdown_name: "Lodge Room (P2)", search_value: "building_class:(P2)" },
							{ name: "Community Center", filter: "P5", dropdown_name: "Community Center (P5)", search_value: "building_class:(P5)" },
						]
					},
					{
						name: "Other Recreational", filter: "EntertainmentRecreational__OtherRecreational", dropdown_name: "Other Recreational", search_value: "",
						children: [
							{ name: "Beach Club", filter: "P4", dropdown_name: "Beach Club (P4)", search_value: "building_class:(P4)" },
							{ name: "Amusement Place, Bath House, Boat House", filter: "P6", dropdown_name: "Amusement/Bath/Boat House (P6)", search_value: "building_class:(P6)" },
							{ name: "Miscellaneous Indoor Public Assembly", filter: "P9", dropdown_name: "Indoor Public Assembly (P9)", search_value: "building_class:(P9)" },
							{ name: "Miscellaneous Outdoor Recreational Facility", filter: "Q9", dropdown_name: "Outdoor Recreational Facility (Q9)", search_value: "building_class:(Q9)" },
							{ name: "Beach", filter: "Q4", dropdown_name: "Beach (Q4)", search_value: "building_class:(Q4)" },
							{ name: "Community Gardens", filter: "QG", dropdown_name: "Community Gardens (QG)", search_value: "building_class:(QG)" },
						]
					},
				]
			},
			// === PUBLIC SERVICES/FACILITIES ===
			{
				name: "Public Services/Facilities", filter: "public-services", dropdown_name: "Public Services/Facilities", search_value: "",
				children: [
					{
						name: "Police/Fire Department", filter: "PublicServicesFacilities__PoliceFireDepartment", dropdown_name: "Police/Fire Department", search_value: "",
						children: [
							{ name: "Fire Department", filter: "Y1", dropdown_name: "Fire Department (Y1)", search_value: "building_class:(Y1)" },
							{ name: "Police Department", filter: "Y2", dropdown_name: "Police Department (Y2)", search_value: "building_class:(Y2)" },
						]
					},
					{
						name: "Post Office", filter: "PublicServicesFacilities__PostOffice", dropdown_name: "Post Office", search_value: "",
						children: [
							{ name: "Post Office", filter: "Z3", dropdown_name: "Post Office (Z3)", search_value: "building_class:(Z3)" },
						]
					},
					{
						name: "Parking", filter: "PublicServicesFacilities__Parking", dropdown_name: "Parking", search_value: "",
						children: [
							{ name: "Indoor Parking", filter: "RG", dropdown_name: "Indoor Parking (RG)", search_value: "building_class:(RG)" },
							{ name: "Outdoor Parking", filter: "RP", dropdown_name: "Outdoor Parking (RP)", search_value: "building_class:(RP)" },
							{ name: "Public Parking Area", filter: "Z2", dropdown_name: "Public Parking Area (Z2)", search_value: "building_class:(Z2)" },
							{ name: "All Parking Garages", filter: "G1", dropdown_name: "All Parking Garages (G1)", search_value: "building_class:(G1)" },
							{ name: "Garage - Residential Tax Class 1", filter: "G0", dropdown_name: "Garage - Residential Tax Class 1 (G0)", search_value: "building_class:(G0)" },
							{ name: "Licensed Parking Lot", filter: "G6", dropdown_name: "Licensed Parking Lot (G6)", search_value: "building_class:(G6)" },
							{ name: "Unlicensed Parking Lot", filter: "G7", dropdown_name: "Unlicensed Parking Lot (G7)", search_value: "building_class:(G7)" },
						]
					},
					{
						name: "Transportation", filter: "PublicServicesFacilities__Transportation", dropdown_name: "Transportation", search_value: "",
						children: [
							{ name: "Miscellaneous Transportation Facility", filter: "T9", dropdown_name: "Misc Transportation Facility (T9)", search_value: "building_class:(T9)" },
							{ name: "Railroad - Private Ownership", filter: "U6", dropdown_name: "Railroad - Private Ownership (U6)", search_value: "building_class:(U6)" },
							{ name: "Transportation - Public Ownership", filter: "U7", dropdown_name: "Transportation - Public Ownership (U7)", search_value: "building_class:(U7)" },
						]
					},
					{
						name: "Airports", filter: "PublicServicesFacilities__Airports", dropdown_name: "Airports", search_value: "",
						children: [
							{ name: "Airport, Airfield, Terminal", filter: "T1", dropdown_name: "Airport, Airfield, Terminal (T1)", search_value: "building_class:(T1)" },
						]
					},
					{
						name: "Utilities", filter: "PublicServicesFacilities__Utilities", dropdown_name: "Utilities", search_value: "",
						children: [
							{ name: "Utility Company Land and Building", filter: "U0", dropdown_name: "Utility Company Land & Bldg (U0)", search_value: "building_class:(U0)" },
							{ name: "Gas or Electric Utility", filter: "U2", dropdown_name: "Gas or Electric Utility (U2)", search_value: "building_class:(U2)" },
							{ name: "Telephone Utility", filter: "U4", dropdown_name: "Telephone Utility (U4)", search_value: "building_class:(U4)" },
							{ name: "Communication Facility Other than Telephone", filter: "U5", dropdown_name: "Communication Facility (U5)", search_value: "building_class:(U5)" },
							{ name: "Miscellaneous Utility Property", filter: "U9", dropdown_name: "Miscellaneous Utility (U9)", search_value: "building_class:(U9)" },
						]
					},
				]
			},
			// === INSTITUTIONAL ===
			{
				name: "Institutional", filter: "institutional", dropdown_name: "Institutional", search_value: "",
				children: [
					{
						name: "Education", filter: "Institutional__Education", dropdown_name: "Education", search_value: "",
						children: [
							{ name: "Public Elementary, Junior or Senior High", filter: "W1", dropdown_name: "Public Elementary/Junior/Senior High (W1)", search_value: "building_class:(W1)" },
							{ name: "Parochial School, Yeshiva", filter: "W2", dropdown_name: "Parochial School, Yeshiva (W2)", search_value: "building_class:(W2)" },
							{ name: "School or Academy", filter: "W3", dropdown_name: "School or Academy (W3)", search_value: "building_class:(W3)" },
							{ name: "Training School", filter: "W4", dropdown_name: "Training School (W4)", search_value: "building_class:(W4)" },
							{ name: "City University", filter: "W5", dropdown_name: "City University (W5)", search_value: "building_class:(W5)" },
							{ name: "Other College and University", filter: "W6", dropdown_name: "Other College and University (W6)", search_value: "building_class:(W6)" },
							{ name: "Theological Seminary", filter: "W7", dropdown_name: "Theological Seminary (W7)", search_value: "building_class:(W7)" },
							{ name: "Other Private School", filter: "W8", dropdown_name: "Other Private School (W8)", search_value: "building_class:(W8)" },
							{ name: "Miscellaneous Educational Facility", filter: "W9", dropdown_name: "Misc Educational Facility (W9)", search_value: "building_class:(W9)" },
						]
					},
					{
						name: "Religious Institutions", filter: "Institutional__ReligiousInstitutions", dropdown_name: "Religious Institutions", search_value: "",
						children: [
							{ name: "Church, Synagogue, Chapel", filter: "M1", dropdown_name: "Church, Synagogue, Chapel (M1)", search_value: "building_class:(M1)" },
							{ name: "Mission House (Non-Residential)", filter: "M2", dropdown_name: "Mission House (M2)", search_value: "building_class:(M2)" },
							{ name: "Parsonage, Rectory", filter: "M3", dropdown_name: "Parsonage, Rectory (M3)", search_value: "building_class:(M3)" },
							{ name: "Convent", filter: "M4", dropdown_name: "Convent (M4)", search_value: "building_class:(M4)" },
							{ name: "Miscellaneous Religious Facility", filter: "M9", dropdown_name: "Misc Religious Facility (M9)", search_value: "building_class:(M9)" },
							{ name: "YWCA, YMCA, YWHA, YMHA, PAL", filter: "P3", dropdown_name: "YWCA, YMCA, YWHA, YMHA, PAL (P3)", search_value: "building_class:(P3)" },
						]
					},
					{
						name: "Hospitals/Health Care", filter: "Institutional__HospitalsHealthCare", dropdown_name: "Hospitals/Health Care", search_value: "",
						children: [
							{ name: "Hospital, Sanitarium, Mental Institution", filter: "I1", dropdown_name: "Hospital, Sanitarium (I1)", search_value: "building_class:(I1)" },
							{ name: "Infirmary", filter: "I2", dropdown_name: "Infirmary (I2)", search_value: "building_class:(I2)" },
							{ name: "Dispensary", filter: "I3", dropdown_name: "Dispensary (I3)", search_value: "building_class:(I3)" },
							{ name: "Hospital - Staff Facility", filter: "I4", dropdown_name: "Hospital - Staff Facility (I4)", search_value: "building_class:(I4)" },
							{ name: "Health Center, Child Center, Clinic", filter: "I5", dropdown_name: "Health Center/Clinic (I5)", search_value: "building_class:(I5)" },
							{ name: "Miscellaneous Hospital, Health Care Facility", filter: "I9", dropdown_name: "Misc Hospital/Health Care (I9)", search_value: "building_class:(I9)" },
						]
					},
					{
						name: "Care Facilities", filter: "Institutional__CareFacilities", dropdown_name: "Care Facilities", search_value: "",
						children: [
							{ name: "Home for Indigent Children, Aged, Homeless", filter: "N2", dropdown_name: "Home for Indigent/Aged/Homeless (N2)", search_value: "building_class:(N2)" },
							{ name: "Orphanage", filter: "N3", dropdown_name: "Orphanage (N3)", search_value: "building_class:(N3)" },
							{ name: "Asylum", filter: "N1", dropdown_name: "Asylum (N1)", search_value: "building_class:(N1)" },
							{ name: "Miscellaneous Asylum, Home", filter: "N9", dropdown_name: "Miscellaneous Asylum, Home (N9)", search_value: "building_class:(N9)" },
							{ name: "Nursing Home", filter: "I6", dropdown_name: "Nursing Home (I6)", search_value: "building_class:(I6)" },
							{ name: "Adult Care Facility", filter: "I7", dropdown_name: "Adult Care Facility (I7)", search_value: "building_class:(I7)" },
						]
					},
					{
						name: "Cemeteries/Funeral Home", filter: "Institutional__CemeteriesFuneralHome", dropdown_name: "Cemeteries/Funeral Home", search_value: "",
						children: [
							{ name: "Cemetery", filter: "Z8", dropdown_name: "Cemetery (Z8)", search_value: "building_class:(Z8)" },
						]
					},
					{
						name: "Correctional Facility", filter: "Institutional__CorrectionalFacility", dropdown_name: "Correctional Facility", search_value: "",
						children: [
							{ name: "Detention House for Wayward Girls", filter: "N4", dropdown_name: "Detention House (N4)", search_value: "building_class:(N4)" },
							{ name: "Prison, Jail, House of Detention", filter: "Y3", dropdown_name: "Prison, Jail, House of Detention (Y3)", search_value: "building_class:(Y3)" },
						]
					},
					{
						name: "Military Facility", filter: "Institutional__MilitaryFacility", dropdown_name: "Military Facility", search_value: "",
						children: [
							{ name: "Military and Naval Installation", filter: "Y4", dropdown_name: "Military and Naval Installation (Y4)", search_value: "building_class:(Y4)" },
						]
					},
				]
			},
			// === OTHER ===
			{
				name: "Other", filter: "other", dropdown_name: "Other", search_value: "",
				children: [
					{
						name: "Commercial", filter: "Other__Commercial", dropdown_name: "Commercial", search_value: "",
						children: [
							{ name: "Miscellaneous Commercial", filter: "R5", dropdown_name: "Miscellaneous Commercial (R5)", search_value: "building_class:(R5)" },
						]
					},
					{
						name: "Miscellaneous", filter: "Other__Miscellaneous", dropdown_name: "Miscellaneous", search_value: "",
						children: [
							{ name: "Bridge, Tunnel, Highway", filter: "U1", dropdown_name: "Bridge, Tunnel, Highway (U1)", search_value: "building_class:(U1)" },
							{ name: "Other Miscellaneous", filter: "Z9", dropdown_name: "Other Miscellaneous (Z9)", search_value: "building_class:(Z9)" },
							{ name: "Pier, Dock, Bulkhead", filter: "T2", dropdown_name: "Pier, Dock, Bulkhead (T2)", search_value: "building_class:(T2)" },
						]
					},
					{
						name: "Government/Exempt", filter: "Other__GovernmentExempt", dropdown_name: "Government/Exempt", search_value: "",
						children: [
							{ name: "Department of Real Estate", filter: "Y5", dropdown_name: "Dept of Real Estate (Y5)", search_value: "building_class:(Y5)" },
							{ name: "Department of Sanitation", filter: "Y6", dropdown_name: "Dept of Sanitation (Y6)", search_value: "building_class:(Y6)" },
							{ name: "Department of Ports and Terminals", filter: "Y7", dropdown_name: "Dept of Ports & Terminals (Y7)", search_value: "building_class:(Y7)" },
							{ name: "Department of Public Works", filter: "Y8", dropdown_name: "Dept of Public Works (Y8)", search_value: "building_class:(Y8)" },
							{ name: "Department of Environmental Protection", filter: "Y9", dropdown_name: "Dept of Environmental Protection (Y9)", search_value: "building_class:(Y9)" },
							{ name: "Foreign Government", filter: "Z4", dropdown_name: "Foreign Government (Z4)", search_value: "building_class:(Z4)" },
							{ name: "United Nations", filter: "Z5", dropdown_name: "United Nations (Z5)", search_value: "building_class:(Z5)" },
							{ name: "Easement", filter: "Z7", dropdown_name: "Easement (Z7)", search_value: "building_class:(Z7)" },
						]
					},
				]
			},
		]
	},
    {
      name: "Building Units",
      show_name: true,
      labels: ["Min Units", "Max Units"],
      search_key: ["min_units", "max_units"],
      filter_key: "total_units",
      filter_type: "building",
      price_filter: true,
      format_type: "number",
      value_prefix: "",
      custom_min_max_values: {
        min: [0, 1, 2, 3, 5, 10, 20, 50, 100, 250],
        max: [1, 2, 3, 5, 10, 20, 50, 100, 250, 500, 1000],
      },
      search_value: ["total_units:[{min_units} TO {max_units}]"],
      values: [],
    },
  ];

export const _buildingSearchCategoryFilter = [
  {
    search_key: "property_category",
    type: "array",
    values: [
      { filter: "all" },
      { filter: "residential" },
      { filter: "office-and-retail" },
      { filter: "public-facilities" },
      { filter: "vacant-land" },
      { filter: "industrial-and-manufacturing" },
      { filter: "transportation-and-utility" },
      { filter: "parking-facilities" },
      { filter: "open-space-and-outdoor-recreation" },
      { filter: "mixed-use" },
      { filter: "commercial" },
      { filter: "unknown" },
    ],
  },
];

export const _buildingSearchFilters = [
  {
    name: "Borough",
    show_name: true,
    search_key: "borough",
    filter_type: "building",
    solr_fq: true,
    values: [
      { name: "Any", filter: "", dropdown_name: "Any", search_value: "" },
      { name: "Manhattan", filter: "manhattan", dropdown_name: "Manhattan", search_value: 'borough:"manhattan"' },
      { name: "Brooklyn", filter: "brooklyn", dropdown_name: "Brooklyn", search_value: 'borough:"brooklyn"' },
      { name: "Queens", filter: "queens", dropdown_name: "Queens", search_value: 'borough:"queens"' },
      { name: "Bronx", filter: "bronx", dropdown_name: "Bronx", search_value: 'borough:"bronx"' },
      { name: "Staten Island", filter: "staten-island", dropdown_name: "Staten Island", search_value: 'borough:"staten island"' },
    ],
  },
  {
    name: "Ownership Type",
    show_name: true,
    search_key: "ownership_type",
    filter_type: "building",
    solr_fq: true,
    show_for_categories: ["residential", "mixed-use", "all"],
    values: [
      { name: "Any", filter: "", dropdown_name: "Any", search_value: "" },
      { name: "Condo", filter: "condo", dropdown_name: "Condo", search_value: 'ownership_type:(*condo*)' },
      { name: "Co-op", filter: "co-op", dropdown_name: "Co-op", search_value: 'ownership_type:(*coop* OR *co?op*)' },
      { name: "Condop", filter: "condop", dropdown_name: "Condop", search_value: 'ownership_type:"condop"' },
      { name: "Rental", filter: "rental", dropdown_name: "Rental", search_value: 'ownership_type:"rental"' },
    ],
  },
  {
    name: "Building Status",
    show_name: true,
    search_key: "building_status",
    filter_type: "building",
    solr_fq: true,
    show_for_categories: ["residential", "mixed-use", "all"],
    values: [
      { name: "Any", filter: "", dropdown_name: "Any", search_value: "" },
      { name: "Sponsor", filter: "sponsor", dropdown_name: "Sponsor", search_value: 'building_status:"sponsor"' },
      { name: "Pipeline", filter: "pipeline", dropdown_name: "Pipeline", search_value: 'building_status:"pipeline"' },
      { name: "Resale", filter: "resale", dropdown_name: "Resale", search_value: 'building_status:"resale"' },
    ],
  },
  {
    name: "Year Built",
    show_name: true,
    labels: ["Min Year", "Max Year"],
    search_key: ["min_year_built", "max_year_built"],
    filter_key: "year_built",
    filter_type: "building",
    format_type: "number",
    solr_fq: true,
    search_value: ["year_built:[{min_year_built} TO {max_year_built}]"],
    values: [],
  },
  {
    name: "Floors",
    show_name: true,
    labels: ["Min Floors", "Max Floors"],
    search_key: ["min_floors", "max_floors"],
    filter_key: "total_floors",
    filter_type: "building",
    format_type: "number",
    solr_fq: true,
    search_value: ["total_floors:[{min_floors} TO {max_floors}]"],
    values: [],
  },
  {
    name: "Total Units",
    show_name: true,
    labels: ["Min Units", "Max Units"],
    search_key: ["min_units", "max_units"],
    filter_key: "total_units",
    filter_type: "building",
    format_type: "number",
    solr_fq: true,
    show_for_categories: ["residential", "mixed-use", "all"],
    search_value: ["total_units:[{min_units} TO {max_units}]"],
    values: [],
  },
];